
import React, { useState, useCallback, useEffect, useRef } from 'react';
import { localToday } from '../../utils/dateUtils';
import { escapeHtml } from '../../utils/escapeHtml';
import { Link, useParams } from 'react-router-dom';
import "./internos.css";
import "../Transferencia/transferencias.css";
import "../Trabalho/trabalho.css";
import Webcam from 'react-webcam';
import Sidebar from '../../components/Sidebar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronRight, faPencilAlt, faEye, faFileAlt, faCalendarDays, faTrash, faHeart as faHeartSolid, faPen, faClock } from '@fortawesome/free-solid-svg-icons';
import { faHeart as faHeartRegular } from '@fortawesome/free-regular-svg-icons';
import { useInternals } from '../../context/internalContext';
import { useEducation } from '../../context/educationContext';
import AddAddress from './addAddress';
import EditAddress from './editAddress';
import Modal from '../../components/modal';
import VisibleAccess from '../../permissions/VisibleAccess';
import AddDocument from './addDocument';
import EditInternal from './editInternal';
import InternalPhone from './internalPhone';
import ProcessAndExecutionTabs from './processAndExecutionTabs';
import AddImage from './addImage';
import Header from '../../components/header';
import ImgPlaceholder from '../../assets/icons/imgplaceholder.svg';
import Lapis from '../../assets/icons/lapis.svg';
import PlusCircle from '../../assets/icons/pluscircle.svg';
import FileIcon from '../../assets/icons/file.svg';
import FormattedInput from '../../components/FormatdInput/formatFunctions';
import Discipline from '../Disciplina/discipline';
import CellMovements from '../Movimentacao/cellMovements.js';
import FactionRelationship from '../Disciplina/factionRelationship.js';
import Drawer from '../../components/Drawer';
import LocationAutocomplete from '../../components/LocationAutocomplete';
import { locationIdFromTypedText, locationLabel, validateLocationSelection } from '../../utils/locationSelection';
import { useUnits } from '../../context/unitsContext';
import { useUsers } from '../../context/usersContext';
import Skeleton from '../../components/Skeleton';
import BinaryImage from '../../components/BinaryImage';
import BinaryFileLink from '../../components/BinaryFileLink';
import InternalPhoto from '../../components/InternalPhoto';
import { BINARY_RESOURCES, hasBinaryField, resolveMainImageRecord, resolveThumbnailField } from '../../utils/binaryFile';
import { toast } from 'react-toastify';

const initialInclusionFormData = {
  name: '',
  nickname: '',
  age: '',
  naturalness_city: '',
  cpf: '',
  pregnancy: false,
  pregnancy_time: '',
  health_situation: '',
  full_uniform: false,
  observation_uniforms: '',
  hygiene_kit: false,
  observation_hygiene_kit: '',
  clothing: '',
  documents_collected: false,
  observation_documents: '',
  other_items_collected: false,
  observation_other_items: '',
  others: '',
  inclusion_date: '',
};

const MESES_TRABALHO = [
  { key: 'jan', label: 'Jan' }, { key: 'fev', label: 'Fev' },
  { key: 'mar', label: 'Mar' }, { key: 'abr', label: 'Abr' },
  { key: 'mai', label: 'Mai' }, { key: 'jun', label: 'Jun' },
  { key: 'jul', label: 'Jul' }, { key: 'ago', label: 'Ago' },
  { key: 'set', label: 'Set' }, { key: 'out', label: 'Out' },
  { key: 'nov', label: 'Nov' }, { key: 'dez', label: 'Dez' },
];

const VISITOR_DETAILS_ALLOWED_GROUPS = [
  'SERVIÇO SOCIAL',
  'ADMINISTRATIVO',
  'DISCIPLINA',
  'PLANTONISTA',
  'GERENTE DE UNIDADE', 'DIRETORES', 'DUAP',
];

function InternalDetails() {
  const {
    getInternalById,
    listInternalImage,
    updateInternalImageMain,
    updateInternalImageActive,
    listAddressByInternal,
    listFiles,
    updateInternalFileActive,
    updateInternal,
    getCicles,
    updateCicle,
    updateTransfer,
    listSocialService,
    listPsychology,
    listOdontology,
    listOdontologyEvolution,
    listAdmissions,
    listNutrition,
    listDisciplinaryFaults,
    listDisciplineNotes,
    getVisitorsByInternalId,
    getMoviments,
    listTemporaryLeavingRecords,
    listInternalInclusion,
    createInternalInclusion,
    updateInternalInclusion,
    listTransfers,
    getProcessInternals,
    getWorkByInternalId,
    listWorklaunch,
    openBinaryFile,
  } = useInternals();
  const { summaryListUnit } = useUnits();
  const { requireWriteUnit } = useUsers();

  const {
    listInternalEducation,
    listReceptioneducational,
    listEducationEvolution,
    listReading,
    listEnrollments,
    listScores,
    listFrequencies,
    listFinalResults,
    listLiteracyIbraema,
  } = useEducation();

  const { internalId } = useParams();
  const [internalDetails, setInternalDetails] = useState(null);
  const [isLoadingDetails, setIsLoadingDetails] = useState(true);
  const [internalAddress, setInternallAddress] = useState([]);
  const [internalImage, setInternalImage] = useState(null);
  const [internalImages, setInternalImages] = useState([]);
  const [files, setFiles] = useState([]);
  const [processesMap, setProcessesMap] = useState({});
  const [relatedVisitors, setRelatedVisitors] = useState([]);
  const [isLoadingVisitors, setIsLoadingVisitors] = useState(false);
  const [temporaryLeavingHistory, setTemporaryLeavingHistory] = useState([]);
  const [isLoadingTemporaryLeavingHistory, setIsLoadingTemporaryLeavingHistory] = useState(false);
  const [visitHistory, setVisitHistory] = useState([]);
  const [isLoadingVisitHistory, setIsLoadingVisitHistory] = useState(false);
  const [internalTransfers, setInternalTransfers] = useState([]);
  const [isLoadingTransfers, setIsLoadingTransfers] = useState(false);
  const [selectedTransferDetail, setSelectedTransferDetail] = useState(null);
  const [isTransferDetailModalOpen, setIsTransferDetailModalOpen] = useState(false);
  const [cicles, setCicles] = useState([]);
  const [showArrivalDateModal, setShowArrivalDateModal] = useState(false);
  const [arrivalDateForm, setArrivalDateForm] = useState('');
  const [isSavingArrivalDate, setIsSavingArrivalDate] = useState(false);
  const [arrivalEditTarget, setArrivalEditTarget] = useState(null); // { type: 'cycle' | 'transfer', id }
  const [isLoadingArrivalTarget, setIsLoadingArrivalTarget] = useState(false);
  const [isTogglingVisit, setIsTogglingVisit] = useState(false);
  const [socialServiceData, setSocialServiceData] = useState(null)
  const [psychologyData, setPsychologyData] = useState(null)
  const [odontologyData, setOdontologyData] = useState(null)
  const [odontologyEvolutions, setOdontologyEvolutions] = useState([]);
  const [healthData, setHealthData] = useState(null)
  const [nutritionData, setNutritionData] = useState(null)
  const [inclusionList, setInclusionList] = useState([])
  const [selectedInclusion, setSelectedInclusion] = useState(null)
  const [isInclusionDrawerOpen, setIsInclusionDrawerOpen] = useState(false)
  const [isInclusionWizardOpen, setIsInclusionWizardOpen] = useState(false);
  const [inclusionWizardStep, setInclusionWizardStep] = useState(1);
  const [inclusionFormData, setInclusionFormData] = useState(initialInclusionFormData);
  // O GET devolve o texto da cidade; o ID só existe quando o usuário escolhe na lista
  const [inclusionNaturalnessName, setInclusionNaturalnessName] = useState('');
  const [inclusionFormId, setInclusionFormId] = useState(null);
  const [inclusionUploadFile, setInclusionUploadFile] = useState(null);
  const [inclusionUploadPreview, setInclusionUploadPreview] = useState('');
  const [existingInclusionRecord, setExistingInclusionRecord] = useState(null);
  const [showInclusionWebcam, setShowInclusionWebcam] = useState(false);
  const [inclusionCameraError, setInclusionCameraError] = useState('');
  const [isSavingInclusion, setIsSavingInclusion] = useState(false);
  const inclusionWebcamRef = useRef(null);
  const inclusionFileInputRef = useRef(null);
  const inclusionCameraInputRef = useRef(null);
  const [unitsMap, setUnitsMap] = useState({});
  const [showLargeImage, setShowLargeImage] = useState(false);
  const [largeImageId, setLargeImageId] = useState(null);
  const [largeImageDescription, setLargeImageDescription] = useState('');
  const [largeImageDetailType, setLargeImageDetailType] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalEditInternalOpen, setIsModalEditInternalOpen] = useState(false);
  const [isModalAddAddress, setIsModalAddAddress] = useState(false);
  const [isModalEditAddress, setIsModalEditAddress] = useState(false);
  const [isModalAddFile, setIsModalAddFile] = useState(false);
  const [currentAddress, setCurrentAddress] = useState(null);

  // estatos para faltas e notas
  const [faults, setFaults] = useState([]);
  const [notesTimeline, setNotesTimeline] = useState([]);
  const [loadingFaults, setLoadingFaults] = useState(true);
  const [loadingNotes, setLoadingNotes] = useState(true);
  const [refreshDicipline, setRefreshDicipline] = useState(0);

  // estatos para faltas e notas
  const [internalEducations, setInternalEducations] = useState([]);
  const [receptionEducations, setReceptionEducations] = useState([]);
  const [educationEvolutions, setEducationEvolutions] = useState([]);
  const [readings, setReadings] = useState([]);
  const [enrollments, setEnrollments] = useState([]);
  const [scores, setScores] = useState([]);
  const [frequencies, setFrequencies] = useState([]);
  const [listFinalResultsData, setFinalResultsData] = useState([]);
  const [ibraemaLiteracy, setIbraemaLiteracy] = useState([]);

  const [internalWorks, setInternalWorks] = useState([]);
  const [workLaunchesMap, setWorkLaunchesMap] = useState({});
  const [isLoadingWorks, setIsLoadingWorks] = useState(false);

  const [accordionState, setAccordionState] = useState({
    dadosGerais: true,
    disciplina: false,
    factionRelationship: false,
    enderecos: false,
    contatos: false,
    processos: false,
    documentos: false,
    ciclos: false,
    servicoSocial: false,
    educacao: false,
    psicologia: false,
    odontologia: false,
    saude: false,
    nutricao: false,
    visitantes: false,
    historicoSaidas: false,
    historicoVisitas: false,
    historicoTransferencias: false,
    inclusao: false,
    historico_cela: false,
    trabalho: false,
  });

  // Alterna o estado do acordeão (expandido/contraído)
  const toggleAccordion = (accordion) => {
    setAccordionState(prevState => ({
      ...prevState,
      [accordion]: !prevState[accordion]
    }));
  };

  // Abre o modal para adicionar imagens
  const handleImageModal = () => {
    setIsModalOpen(true);
  };

  // Abre o modal para editar o interno
  const handleEditInternal = () => {
    setIsModalEditInternalOpen(true);
  };

  // Abre o modal para adicionar um endereço
  const handleAddAddress = () => {
    setIsModalAddAddress(true);
  };

  // Abre o modal para editar um endereço específico
  const handleEditAddress = address => {
    setCurrentAddress(address);
    setIsModalEditAddress(true);
  };

  // Abre o modal para adicionar um arquivo
  const handleAddFile = () => {
    setIsModalAddFile(true);
  };

  // Exibe a imagem em tamanho grande quando clicada
  const handleThumbnailClick = (imageId, description, detailType) => {
    setLargeImageId(imageId);
    setLargeImageDescription(description);
    setLargeImageDetailType(detailType);
    setShowLargeImage(true);
  };

  // Fecha a visualização da imagem em tamanho grande
  const handleCloseLargeImage = () => {
    setShowLargeImage(false);
    setLargeImageId(null);
  };

  // Busca os detalhes do interno
  const fetchInternalDetails = useCallback(async () => {
    setIsLoadingDetails(true);
    try {
      const internalData = await getInternalById(internalId);
      setInternalDetails(internalData);
    } catch (error) {
      console.error('Erro ao buscar os detalhes do interno:', error);
      setInternalDetails(null);
    } finally {
      setIsLoadingDetails(false);
    }
  }, [internalId, getInternalById]);

  useEffect(() => {
    fetchInternalDetails();
  }, [fetchInternalDetails, internalId]);

  // Busca os endereços do interno
  const fetchAddresses = useCallback(async () => {
    try {
      // Substitua pela função correta que chama a API com o ID do interno
      const response = await listAddressByInternal(internalId);

      // Certifique-se de que o formato da resposta esteja correto
      if (response && Array.isArray(response)) {
        setInternallAddress(response); // Atualize o estado com os endereços
      }
    } catch (error) {
      console.error("Erro ao buscar endereços:", error);
      setInternallAddress([]); // Reseta o estado em caso de erro
    }
  }, [internalId, listAddressByInternal]);

  useEffect(() => {
    fetchAddresses();
  }, [fetchAddresses]);

  // Ordena as imagens do interno pela ordem de criação (mais antiga primeiro),
  // usando o campo "date" retornado pela API (timestamp de criação da imagem).
  const sortImagesByCreation = (images) => {
    return [...images].sort((a, b) => {
      const aDate = new Date(a.date || 0).getTime();
      const bDate = new Date(b.date || 0).getTime();
      if (aDate !== bDate) return aDate - bDate;
      return (a.id || 0) - (b.id || 0);
    });
  };

  // Busca as imagens do interno
  useEffect(() => {
    const fetchInternalImage = async () => {
      try {
        const response = await listInternalImage(internalId);
        if (response && Array.isArray(response.data)) {
          const filteredImages = sortImagesByCreation(response.data.filter(image => image.internal === internalId));
          setInternalImages(filteredImages);

          // Pega a imagem principal como padrão (registro com id, a foto sai pela rota binary)
          setInternalImage(resolveMainImageRecord(filteredImages));
        } else {
          setInternalImages([]);
          setInternalImage(null);
        }
      } catch (error) {
        console.error("Erro ao buscar as imagens do interno:", error);
        setInternalImages([]);
        setInternalImage(null);
      }
    };

    fetchInternalImage();
  }, [internalId, listInternalImage]);

  const updateInternalImages = async () => {
    try {
      const response = await listInternalImage(internalId);
      if (response && Array.isArray(response.data)) {
        const filteredImages = sortImagesByCreation(response.data.filter(image => image.internal === internalId));
        setInternalImages(filteredImages);

        // Pega a imagem principal como padrão (registro com id, a foto sai pela rota binary)
        setInternalImage(resolveMainImageRecord(filteredImages));
      } else {
        setInternalImages([]);
        setInternalImage(null);
      }
    } catch (error) {
      console.error("Erro ao atualizar as imagens do interno:", error);
      setInternalImages([]);
      setInternalImage(null);
    }
  };

  const handleSetMainImage = async (imageId) => {
    try {
      await updateInternalImageMain(imageId);
      await updateInternalImages();
    } catch (error) {
      // erro já tratado no contexto
    }
  };

  const handleDeleteImage = async (imageId) => {
    if (!window.confirm("Deseja realmente remover esta imagem?")) return;
    try {
      await updateInternalImageActive(imageId, false);
      await updateInternalImages();
    } catch (error) {
      console.error("Erro ao remover imagem:", error);
    }
  };

  const handleDeleteFile = async (fileId) => {
    if (!window.confirm("Deseja realmente remover este documento?")) return;
    try {
      await updateInternalFileActive(fileId, false);
      toast.success("Documento removido com sucesso.");
      await fetchFiles();
    } catch (error) {
      console.error("Erro ao remover arquivo:", error);
    }
  };

  // Busca os arquivos do interno
  const fetchFiles = useCallback(async () => {
    try {
      const response = await listFiles(internalId);
      if (response && Array.isArray(response.data)) {
        setFiles(response.data);

        const hasProcessLinks = response.data.some((f) => f.process !== null && f.process !== undefined);
        if (hasProcessLinks) {
          const processesResponse = await getProcessInternals({ internal: internalId });
          const processList = Array.isArray(processesResponse?.results)
            ? processesResponse.results
            : (Array.isArray(processesResponse) ? processesResponse : []);
          const map = {};
          processList.forEach((p) => { map[p.id] = p.number; });
          setProcessesMap(map);
        }
      }
    } catch (error) {
      setFiles([]);
    }
  }, [listFiles, getProcessInternals, internalId]);

  useEffect(() => {
    if (accordionState.documentos && internalId) {
      fetchFiles();
    }
  }, [accordionState.documentos, internalId, fetchFiles]);

  // Visitantes relacionados ao interno
  useEffect(() => {
    if (!accordionState.visitantes || !internalId) {
      return;
    }

    let isActive = true;

    const fetchRelatedVisitors = async () => {
      setIsLoadingVisitors(true);
      setRelatedVisitors([]);

      try {
        const visitors = await getVisitorsByInternalId(internalId);
        const uniqueVisitors = Array.from(
          new Map(
            visitors
              .filter(Boolean)
              .map((visitor, index) => [
                String(visitor?.id || `${visitor?.cpf || ''}-${visitor?.name || ''}-${index}`),
                visitor,
              ])
          ).values()
        );

        if (isActive) {
          setRelatedVisitors(uniqueVisitors);
        }
      } catch (error) {
        console.error('Erro ao buscar visitantes relacionados ao interno:', error);
        if (isActive) {
          setRelatedVisitors([]);
        }
      } finally {
        if (isActive) {
          setIsLoadingVisitors(false);
        }
      }
    };

    fetchRelatedVisitors();

    return () => {
      isActive = false;
    };
  }, [accordionState.visitantes, internalId, getVisitorsByInternalId]);

  // Histórico de saídas do interno
  useEffect(() => {
    if (!accordionState.historicoSaidas || !internalId) {
      return;
    }

    let isActive = true;

    const fetchTemporaryLeavingHistory = async () => {
      setIsLoadingTemporaryLeavingHistory(true);
      setTemporaryLeavingHistory([]);

      try {
        const response = await listTemporaryLeavingRecords({
          internal: internalId,
          ordering: '-leaving_date',
          limit: 50,
        });

        const historyItems = Array.isArray(response?.results)
          ? response.results
          : Array.isArray(response)
            ? response
            : [];

        if (isActive) {
          setTemporaryLeavingHistory(historyItems);
        }
      } catch (error) {
        console.error('Erro ao buscar histórico de saídas do interno:', error);
        if (isActive) {
          setTemporaryLeavingHistory([]);
        }
      } finally {
        if (isActive) {
          setIsLoadingTemporaryLeavingHistory(false);
        }
      }
    };

    fetchTemporaryLeavingHistory();

    return () => {
      isActive = false;
    };
  }, [accordionState.historicoSaidas, internalId, listTemporaryLeavingRecords]);

  // Histórico de visitas recebidas pelo interno (todas as unidades)
  useEffect(() => {
    if (!accordionState.historicoVisitas || !internalId) {
      return;
    }

    let isActive = true;

    const fetchVisitHistory = async () => {
      setIsLoadingVisitHistory(true);
      setVisitHistory([]);

      try {
        let allVisits = [];
        let offset = 0;
        const limit = 100;
        let count = 0;
        do {
          const response = await getMoviments({
            internal: internalId,
            moviment: 'Entrada',
            ordering: '-date',
            limit,
            offset,
          });
          const results = response?.results || [];
          allVisits = [...allVisits, ...results];
          count = response?.count || 0;
          offset += limit;
        } while (offset < count);

        if (isActive) {
          setVisitHistory(allVisits);
        }
      } catch (error) {
        console.error('Erro ao buscar histórico de visitas do interno:', error);
        if (isActive) {
          setVisitHistory([]);
        }
      } finally {
        if (isActive) {
          setIsLoadingVisitHistory(false);
        }
      }
    };

    fetchVisitHistory();

    return () => {
      isActive = false;
    };
  }, [accordionState.historicoVisitas, internalId, getMoviments]);

  // Histórico de transferências do interno
  useEffect(() => {
    if (!accordionState.historicoTransferencias || !internalId) {
      return;
    }

    let isActive = true;

    const fetchInternalTransfers = async () => {
      setIsLoadingTransfers(true);
      setInternalTransfers([]);

      try {
        const response = await listTransfers({ internal: internalId, limit: 50 });
        const items = Array.isArray(response?.results) ? response.results : [];
        if (isActive) {
          setInternalTransfers(items);
        }
      } catch (error) {
        if (isActive) {
          setInternalTransfers([]);
        }
      } finally {
        if (isActive) {
          setIsLoadingTransfers(false);
        }
      }
    };

    fetchInternalTransfers();

    return () => {
      isActive = false;
    };
  }, [accordionState.historicoTransferencias, internalId, listTransfers]);

  // Busca os ciclos do interno
  const fetchCicles = useCallback(async () => {
    try {
      const ciclesData = await getCicles({ internal: internalId });
      const normalizedCicles = Array.isArray(ciclesData?.results) ? ciclesData.results : [];
      setCicles(normalizedCicles);
    } catch (error) {
      console.error('Erro ao buscar os ciclos do interno:', error);
      setCicles([]);
    }
  }, [internalId, getCicles]);

  useEffect(() => {
    fetchCicles();
  }, [fetchCicles, internalId]);



  // --- Accordions: Fetch data only when opened ---

  // Serviço Social
  useEffect(() => {
    if (accordionState.servicoSocial) {
      const fetchSocialServiceData = async () => {
        try {
          const response = await listSocialService(internalId);
          const results = Array.isArray(response?.results) ? response.results : [];
          setSocialServiceData(results[0] || null);
        } catch (error) {
          console.error('Erro ao buscar dados de serviço social:', error);
          setSocialServiceData(null);
        }
      };
      fetchSocialServiceData();
    }
  }, [accordionState.servicoSocial, internalId, listSocialService]);

  // Psicologia
  useEffect(() => {
    if (accordionState.psicologia) {
      const fetchPsychologyData = async () => {
        try {
          const response = await listPsychology(internalId);
          const results = Array.isArray(response?.results) ? response.results : [];
          if (results.length > 0) {
            setPsychologyData(results[0]);
          } else {
            setPsychologyData(null);
          }
        } catch (error) {
          setPsychologyData(null);
          console.log('Erro ao buscar dados de psicologia')
        }
      }
      fetchPsychologyData();
    }
  }, [accordionState.psicologia, internalId, listPsychology]);

  // Odontologia
  useEffect(() => {
    if (accordionState.odontologia) {
      const fetchOdontologyData = async () => {
        try {
          const [odontologyResponse, evolutionResponse] = await Promise.all([
            listOdontology(internalId),
            listOdontologyEvolution(internalId),
          ]);

          const odontologyResults = Array.isArray(odontologyResponse?.results)
            ? odontologyResponse.results
            : [];

          const evolutionResults = Array.isArray(evolutionResponse?.results)
            ? evolutionResponse.results
            : [];

          setOdontologyData(odontologyResults[0] || null);
          setOdontologyEvolutions(evolutionResults);
        } catch (error) {
          setOdontologyData(null);
          setOdontologyEvolutions([]);
        }
      }
      fetchOdontologyData();
    }
  }, [accordionState.odontologia, internalId, listOdontology, listOdontologyEvolution]);

  // Saúde
  useEffect(() => {
    if (accordionState.saude) {
      const fetchHealthData = async () => {
        try {
          const response = await listAdmissions({ internal__id: internalId });
          const results = Array.isArray(response?.results) ? response.results : [];
          if (results.length === 0) {
            setHealthData(null);
            return;
          }
          const sorted = [...results].sort((a, b) => {
            const ad = new Date(a.created_at || a.date || 0).getTime();
            const bd = new Date(b.created_at || b.date || 0).getTime();
            return bd - ad;
          });
          setHealthData(sorted[0]);
        } catch (error) {
          setHealthData(null);
        }
      };
      fetchHealthData();
    }
  }, [accordionState.saude, internalId, listAdmissions]);

  // Nutrição
  useEffect(() => {
    if (accordionState.nutricao) {
      const fetchNutritionData = async () => {
        try {
          const response = await listNutrition({ internal: internalId });
          const results = Array.isArray(response?.results) ? response.results : [];
          setNutritionData(results.length > 0 ? results[0] : null);
        } catch (error) {
          setNutritionData(null);
        }
      };
      fetchNutritionData();
    }
  }, [accordionState.nutricao, internalId, listNutrition]);

  // Disciplina (faltas e notas)
  useEffect(() => {
    if (accordionState.disciplina) {
      const fetchFaults = async () => {
        if (!internalId) return;
        setLoadingFaults(true);
        try {
          const response = await listDisciplinaryFaults({ internal: internalId, start_date: '2025-01-01' });
          setFaults(Array.isArray(response?.results) ? response.results : []);
        } catch (error) {
          setFaults([]);
          console.error('Erro ao buscar faltas disciplinares:', error);
        } finally {
          setLoadingFaults(false);
        }
      };

      const fetchNotes = async () => {
        if (!internalId) return;
        setLoadingNotes(true);
        try {
          const response = await listDisciplineNotes({ internal: internalId, start_date: '2025-01-01' });
          setNotesTimeline(Array.isArray(response?.results) ? response.results : []);
        } catch (error) {
          setNotesTimeline([]);
          console.error('Erro ao buscar notas disciplinares:', error);
        } finally {
          setLoadingNotes(false);
        }
      };

      fetchFaults();
      fetchNotes();
    }
  }, [accordionState.disciplina, internalId, listDisciplinaryFaults, listDisciplineNotes, refreshDicipline]);

  // Educação
  useEffect(() => {
    if (accordionState.education && internalId) {
      const fetchAllEducationData = async () => {
        try {
          const [
            internalEducationRes,
            receptionEducationRes,
            evolutionRes,
            readingRes,
            enrollmentRes,
            scoreRes,
            frequencyRes,
            finalResultRes,
            ibraemaRes,
          ] = await Promise.all([
            listInternalEducation({ internal: internalId, start_date: '2023-01-01' }),
            listReceptioneducational({ internal: internalId, start_date: '2023-01-01' }),
            listEducationEvolution({ internal: internalId, start_date: '2023-01-01' }),
            listReading({ internal: internalId, start_date: '2023-01-01' }),
            listEnrollments({ internal: internalId, start_date: '2023-01-01' }),
            listScores({ internal: internalId, start_date: '2023-01-01' }),
            listFrequencies({ internal: internalId, start_date: '2023-01-01' }),
            listFinalResults({ internal: internalId, start_date: '2023-01-01' }),
            listLiteracyIbraema({ internal: internalId, start_date: '2023-01-01' }),
          ]);

          setInternalEducations(Array.isArray(internalEducationRes?.results) ? internalEducationRes.results : []);
          setReceptionEducations(Array.isArray(receptionEducationRes?.results) ? receptionEducationRes.results : []);
          setEducationEvolutions(Array.isArray(evolutionRes?.results) ? evolutionRes.results : []);
          setReadings(Array.isArray(readingRes?.results) ? readingRes.results : []);
          setEnrollments(Array.isArray(enrollmentRes?.results) ? enrollmentRes.results : []);
          setScores(Array.isArray(scoreRes?.results) ? scoreRes.results : []);
          setFrequencies(Array.isArray(frequencyRes?.results) ? frequencyRes.results : []);
          setFinalResultsData(Array.isArray(finalResultRes?.results) ? finalResultRes.results : []);
          setIbraemaLiteracy(Array.isArray(ibraemaRes?.results) ? ibraemaRes.results : []);
        } catch (error) {
          setInternalEducations([]);
          setReceptionEducations([]);
          setEducationEvolutions([]);
          setReadings([]);
          setEnrollments([]);
          setScores([]);
          setFrequencies([]);
          setFinalResultsData([]);
          setIbraemaLiteracy([]);
          console.error('Erro ao carregar dados educacionais do interno:', error);
        }
      };
      fetchAllEducationData();
    }
  }, [
    accordionState.education,
    internalId,
    listInternalEducation,
    listReceptioneducational,
    listEducationEvolution,
    listReading,
    listEnrollments,
    listScores,
    listFrequencies,
    listFinalResults,
    listLiteracyIbraema
  ]);

  const internalName = internalDetails?.name;

  useEffect(() => {
    if (!accordionState.trabalho || !internalId || !internalName) return;
    let isMounted = true;
    const fetchWorks = async () => {
      setIsLoadingWorks(true);
      try {
        const worksRes = await getWorkByInternalId(internalId, internalName);
        const works = worksRes?.results || [];
        if (!isMounted) return;
        setInternalWorks(works);

        const launchEntries = await Promise.all(
          works.map(async (work) => {
            try {
              const res = await listWorklaunch(work.id);
              return [work.id, res?.results || []];
            } catch {
              return [work.id, []];
            }
          })
        );
        if (isMounted) setWorkLaunchesMap(Object.fromEntries(launchEntries));
      } catch {
        if (isMounted) { setInternalWorks([]); setWorkLaunchesMap({}); }
      } finally {
        if (isMounted) setIsLoadingWorks(false);
      }
    };
    fetchWorks();
    return () => { isMounted = false; };
  }, [accordionState.trabalho, internalId, internalName, getWorkByInternalId, listWorklaunch]);

  const fetchInclusionList = useCallback(async () => {
    if (!internalId) return;

    try {
      const cpf = String(internalDetails?.cpf || '').replace(/\D/g, '');

      if (cpf) {
        // Interno com CPF: busca exata pelo CPF
        const response = await listInternalInclusion({ cpf });
        const rawList = Array.isArray(response)
          ? response
          : (Array.isArray(response?.results) ? response.results : []);
        const list = rawList.filter(
          (item) => String(item?.cpf || '').replace(/\D/g, '') === cpf
        );
        setInclusionList(list);
        return;
      }

      // Interno sem CPF: busca pelo nome e filtra pelo ID do interno no cliente
      const name = String(internalDetails?.name || '').trim();
      if (!name) {
        setInclusionList([]);
        return;
      }

      const response = await listInternalInclusion({ name });
      const rawList = Array.isArray(response)
        ? response
        : (Array.isArray(response?.results) ? response.results : []);

      // Tenta restringir pelo ID do interno caso o campo venha na resposta
      const hasInternalField = rawList.some(
        (item) => item?.internal !== undefined
      );
      const list = hasInternalField
        ? rawList.filter((item) => {
            const itemInternalId = item?.internal?.id ?? item?.internal;
            return String(itemInternalId) === String(internalId);
          })
        : rawList;

      setInclusionList(list);
    } catch (error) {
      console.error('Erro ao buscar ficha de inclusão:', error);
      setInclusionList([]);
    }
  }, [internalDetails?.cpf, internalDetails?.name, internalId, listInternalInclusion]);

  useEffect(() => {
    if (accordionState.inclusao && internalId) {
      fetchInclusionList();
    }
  }, [accordionState.inclusao, internalId, fetchInclusionList]);

  useEffect(() => {
    if (!accordionState.inclusao) return;

    const fetchAllUnits = async () => {
      try {
        const response = await summaryListUnit();
        const units = Array.isArray(response?.message)
          ? response.message
          : (Array.isArray(response?.results) ? response.results : (Array.isArray(response) ? response : []));
        const map = {};
        units.forEach((unit) => {
          map[unit.id] = unit;
        });
        setUnitsMap(map);
      } catch (error) {
        console.error('Erro ao buscar unidades:', error);
        setUnitsMap({});
      }
    };

    fetchAllUnits();
  }, [accordionState.inclusao, summaryListUnit]);

  const handleOpenInclusionDrawer = (item) => {
    setSelectedInclusion(item);
    setIsInclusionDrawerOpen(true);
  };

  const handleCloseInclusionDrawer = () => {
    setIsInclusionDrawerOpen(false);
    setSelectedInclusion(null);
  };

  const formatInclusionDate = (value) => {
    if (!value) return '-';
    try {
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return value;
      return date.toLocaleDateString('pt-BR');
    } catch (e) {
      return value;
    }
  };

  const inclusionBooleanFields = new Set([
    'pregnancy',
    'full_uniform',
    'hygiene_kit',
    'documents_collected',
    'other_items_collected',
  ]);

  const inclusionNormalizedTextFields = new Set([
    'name',
    'nickname',
    'pregnancy_time',
    'health_situation',
    'observation_uniforms',
    'observation_hygiene_kit',
    'clothing',
    'others',
    'observation_documents',
    'observation_other_items',
  ]);

  const normalizeUpperNoAccent = (value) => {
    if (!value) return '';
    return String(value)
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toUpperCase();
  };

  const normalizeCpfDigits = (value) => String(value || '').replace(/\D/g, '').slice(0, 11);

  const calculateAgeFromBirthDate = (birthDate) => {
    if (!birthDate) return '';
    const date = new Date(birthDate);
    if (Number.isNaN(date.getTime())) return '';
    const today = new Date();
    let age = today.getFullYear() - date.getFullYear();
    const monthDiff = today.getMonth() - date.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < date.getDate())) {
      age -= 1;
    }
    return age;
  };

  const getLatestInclusionItem = (list = []) => {
    const safeList = Array.isArray(list) ? list : [];
    if (!safeList.length) return null;
    return [...safeList].sort((a, b) => {
      const aDate = new Date(a.updated_at || a.created_at || a.inclusion_date || 0).getTime();
      const bDate = new Date(b.updated_at || b.created_at || b.inclusion_date || 0).getTime();
      return bDate - aDate;
    })[0] || null;
  };

  const buildInclusionFormData = (baseInternal, inclusionSource = null) => {
    if (inclusionSource) {
      return {
        ...initialInclusionFormData,
        name: normalizeUpperNoAccent(inclusionSource.name),
        nickname: normalizeUpperNoAccent(inclusionSource.nickname),
        age: inclusionSource.age ?? '',
        cpf: normalizeCpfDigits(inclusionSource.cpf),
        pregnancy: !!inclusionSource.pregnancy,
        pregnancy_time: normalizeUpperNoAccent(inclusionSource.pregnancy_time),
        health_situation: normalizeUpperNoAccent(inclusionSource.health_situation),
        full_uniform: !!inclusionSource.full_uniform,
        observation_uniforms: normalizeUpperNoAccent(inclusionSource.observation_uniforms),
        hygiene_kit: !!inclusionSource.hygiene_kit,
        observation_hygiene_kit: normalizeUpperNoAccent(inclusionSource.observation_hygiene_kit),
        clothing: normalizeUpperNoAccent(inclusionSource.clothing),
        documents_collected: !!inclusionSource.documents_collected,
        observation_documents: normalizeUpperNoAccent(inclusionSource.observation_documents),
        other_items_collected: !!inclusionSource.other_items_collected,
        observation_other_items: normalizeUpperNoAccent(inclusionSource.observation_other_items),
        others: normalizeUpperNoAccent(inclusionSource.others),
        inclusion_date: inclusionSource.inclusion_date || localToday(),
      };
    }

    const cpfDigits = normalizeCpfDigits(baseInternal?.cpf);
    return {
      ...initialInclusionFormData,
      name: normalizeUpperNoAccent(baseInternal?.name),
      cpf: cpfDigits,
      age: calculateAgeFromBirthDate(baseInternal?.date_of_birth),
      inclusion_date: localToday(),
    };
  };

  const openFileDialog = (inputRef) => {
    if (!inputRef?.current) return;
    inputRef.current.value = '';
    inputRef.current.click();
  };

  const openCameraDialog = (inputRef) => {
    if (!inputRef?.current) return;
    inputRef.current.value = '';
    inputRef.current.click();
  };

  const handleOpenInclusionWizard = async (inclusionItem = null) => {
    try {
      const baseInternal = internalDetails || await getInternalById(internalId);
      if (!baseInternal) {
        toast.error('Não foi possível carregar os dados do interno.');
        return;
      }

      const fallbackInclusion = inclusionItem || getLatestInclusionItem(inclusionList);
      const formData = buildInclusionFormData(baseInternal, fallbackInclusion);

      setInclusionFormData(formData);
      setInclusionNaturalnessName(
        fallbackInclusion
          ? (locationLabel(fallbackInclusion.naturalness_city) || locationLabel(fallbackInclusion.naturalness))
          : locationLabel(baseInternal?.naturalness_city)
      );
      setInclusionFormId(fallbackInclusion?.id || null);
      setExistingInclusionRecord(fallbackInclusion || null);
      setInclusionUploadFile(null);
      setInclusionUploadPreview('');
      setShowInclusionWebcam(false);
      setInclusionCameraError('');
      setInclusionWizardStep(1);
      setIsInclusionDrawerOpen(false);
      setSelectedInclusion(null);
      setIsInclusionWizardOpen(true);
    } catch (error) {
      console.error('Erro ao preparar ficha de inclusão para edição:', error);
      toast.error('Não foi possível abrir a ficha de inclusão.');
    }
  };

  const handleCloseInclusionWizard = () => {
    setIsInclusionWizardOpen(false);
    setInclusionWizardStep(1);
    setInclusionFormId(null);
    setInclusionFormData(initialInclusionFormData);
    setInclusionNaturalnessName('');
    setInclusionUploadFile(null);
    setInclusionUploadPreview('');
    setExistingInclusionRecord(null);
    setShowInclusionWebcam(false);
    setInclusionCameraError('');
    setIsSavingInclusion(false);
  };

  useEffect(() => {
    return () => {
      if (inclusionUploadPreview && inclusionUploadPreview.startsWith('blob:')) {
        URL.revokeObjectURL(inclusionUploadPreview);
      }
    };
  }, [inclusionUploadPreview]);

  const handleInclusionFormChange = (event) => {
    const { name, value } = event.target;

    if (name === 'cpf') {
      setInclusionFormData((prev) => ({ ...prev, cpf: normalizeCpfDigits(value) }));
      return;
    }

    const parsedValue = inclusionBooleanFields.has(name)
      ? value === 'true'
      : inclusionNormalizedTextFields.has(name)
        ? normalizeUpperNoAccent(value)
        : value;

    setInclusionFormData((prev) => ({
      ...prev,
      [name]: parsedValue,
    }));
  };

  const handleInclusionNaturalnessChange = (text) => {
    setInclusionNaturalnessName(text);
    setInclusionFormData((prev) => ({ ...prev, naturalness_city: locationIdFromTypedText(text) }));
  };

  const handleInclusionNaturalnessSelect = (city) => {
    setInclusionNaturalnessName(city.name);
    setInclusionFormData((prev) => ({ ...prev, naturalness_city: city.id }));
  };

  const handleGenerateInclusionPdf = () => {
    if (!internalId) {
      toast.error('Nenhum interno selecionado.');
      return;
    }

    const pdfWindow = window.open('', '_blank');
    if (!pdfWindow) {
      toast.error('Permita pop-ups para gerar o PDF.');
      return;
    }

    // Todo valor vai pro HTML escapado: o PDF é aberto com document.write na origem do sistema.
    const toPdfText = (value) => (value === null || value === undefined || value === '' ? '-' : String(value));
    const formatValueForPdf = (value) => escapeHtml(toPdfText(value));
    const boolLabel = (value) => (value ? 'Sim' : 'Não');
    const upperValue = (value) => escapeHtml(normalizeUpperNoAccent(toPdfText(value)));
    const formatDatePtBr = (value) => {
      if (!value) return '-';
      const dateOnly = String(value).split('T')[0];
      const parts = dateOnly.split('-');
      if (parts.length === 3 && parts[0].length === 4) {
        return escapeHtml(`${parts[2]}/${parts[1]}/${parts[0]}`);
      }
      const parsedDate = new Date(value);
      if (Number.isNaN(parsedDate.getTime())) return formatValueForPdf(value);
      return parsedDate.toLocaleDateString('pt-BR');
    };

    const html = `
      <html>
        <head>
          <title>Ficha de Inclusão</title>
          <style>
            @page { size: A4 portrait; margin: 8mm; }
            body { font-family: Arial, sans-serif; padding: 8px; color: #1f2937; font-size: 10px; line-height: 1.2; }
            h1 { font-size: 15px; margin-bottom: 4px; text-align: center; text-transform: uppercase; }
            table { width: 100%; border-collapse: collapse; margin-top: 8px; page-break-inside: avoid; break-inside: avoid; }
            td { padding: 4px 6px; border: 1px solid #e5e7eb; font-size: 10px; vertical-align: top; }
            td.label { background: #f3f4f6; font-weight: 600; width: 35%; text-transform: uppercase; }
            .section { margin-top: 10px; font-size: 10px; font-weight: 700; text-transform: uppercase; background: #f3f4f6; padding: 4px 6px; border: 1px solid #e5e7eb; page-break-after: avoid; break-after: avoid; }
            .signature { margin-top: 32px; display: flex; flex-direction: column; align-items: center; font-size: 10px; page-break-inside: avoid; break-inside: avoid; }
            .signature-line { width: 70%; border-bottom: 1px solid #111827; margin-bottom: 4px; }
            .notice { margin-top: 8px; font-size: 9px; text-transform: uppercase; page-break-inside: avoid; break-inside: avoid; }
          </style>
        </head>
        <body>
          <h1>Ficha de Inclusão de Interno</h1>
          <div class="section">Identificação do Interno</div>
          <table>
            <tr><td class="label">Nome</td><td>${upperValue(inclusionFormData.name)}</td></tr>
            <tr><td class="label">Vulgo</td><td>${upperValue(inclusionFormData.nickname)}</td></tr>
            <tr><td class="label">CPF</td><td>${formatValueForPdf(inclusionFormData.cpf)}</td></tr>
            <tr><td class="label">Idade</td><td>${formatValueForPdf(inclusionFormData.age)}</td></tr>
            <tr><td class="label">Naturalidade</td><td>${upperValue(inclusionNaturalnessName)}</td></tr>
          </table>
          <div class="section">Informações gerais estado de saúde</div>
          <table>
            <tr><td class="label">Gravidez</td><td>${boolLabel(inclusionFormData.pregnancy)}</td></tr>
            <tr><td class="label">Tempo de gravidez</td><td>${upperValue(inclusionFormData.pregnancy_time)}</td></tr>
            <tr><td class="label">Outras enfermidades / situação</td><td>${upperValue(inclusionFormData.health_situation)}</td></tr>
          </table>
          <div class="section">Material entregue à interna</div>
          <table>
            <tr><td class="label">Fardamento completo</td><td>${boolLabel(inclusionFormData.full_uniform)}</td></tr>
            <tr><td class="label">Observação uniforme</td><td>${upperValue(inclusionFormData.observation_uniforms)}</td></tr>
            <tr><td class="label">Kit higiene/limpeza</td><td>${boolLabel(inclusionFormData.hygiene_kit)}</td></tr>
            <tr><td class="label">Observação kit higiene</td><td>${upperValue(inclusionFormData.observation_hygiene_kit)}</td></tr>
            <tr><td class="label">Outros</td><td>${upperValue(inclusionFormData.others)}</td></tr>
          </table>
          <div class="section">Itens recolhidos</div>
          <table>
            <tr><td class="label">Itens recolhidos (joias, documentos etc.)</td><td>${boolLabel(inclusionFormData.documents_collected)}</td></tr>
            <tr><td class="label">Observação documentos</td><td>${upperValue(inclusionFormData.observation_documents)}</td></tr>
            <tr><td class="label">Vestuário</td><td>${upperValue(inclusionFormData.clothing)}</td></tr>
            <tr><td class="label">Outros itens recolhidos</td><td>${boolLabel(inclusionFormData.other_items_collected)}</td></tr>
            <tr><td class="label">Observação outros itens</td><td>${upperValue(inclusionFormData.observation_other_items)}</td></tr>
          </table>
          <table>
            <tr><td class="label">Data</td><td>${formatDatePtBr(inclusionFormData.inclusion_date)}</td></tr>
          </table>
          <div class="notice">
            OBS: É TERMINANTEMENTE PROIBIDO RISCAR/DANIFICAR QUALQUER PAREDE/CELA DESTA UNIDADE (ART.163, III, CPB: DANO AO PATRIMÔNIO PÚBLICO, DETENÇÃO: DE SEIS MESES A TRÊS ANOS, E MULTA, ALÉM DA PENA CORRESPONDENTE À VIOLÊNCIA).
          </div>
          <div class="signature">
            <div class="signature-line"></div>
            <div>Assinatura do Interno (ciente)</div>
            <div>${upperValue(inclusionFormData.name)}</div>
          </div>
        </body>
      </html>
    `;

    pdfWindow.document.write(html);
    pdfWindow.document.close();
    pdfWindow.focus();
    pdfWindow.print();

    setInclusionWizardStep(2);
  };

  const handleInclusionUploadContainerClick = () => {
    if (showInclusionWebcam) return;

    setInclusionCameraError('');

    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      openCameraDialog(inclusionCameraInputRef);
      return;
    }

    setShowInclusionWebcam(true);
  };

  const handleInclusionUploadChange = (event) => {
    const file = event.target.files?.[0] || null;

    if (
      file
      && !file.type?.startsWith('image/')
      && file.type !== 'application/pdf'
    ) {
      toast.error('Envie um arquivo em imagem ou PDF.');
      return;
    }

    if (!file) {
      setInclusionUploadFile(null);
      setInclusionUploadPreview('');
      return;
    }

    setInclusionUploadFile(file);
    setShowInclusionWebcam(false);
    setInclusionCameraError('');

    if (file.type?.startsWith('image/')) {
      setInclusionUploadPreview(URL.createObjectURL(file));
      return;
    }

    setInclusionUploadPreview('');
  };

  const captureInclusionFromWebcam = async () => {
    if (!inclusionWebcamRef.current) return;

    const imageSrc = inclusionWebcamRef.current.getScreenshot();
    if (!imageSrc) return;

    const response = await fetch(imageSrc);
    const blob = await response.blob();
    const file = new window.File([blob], 'ficha_inclusao_assinada.jpg', { type: 'image/jpeg' });

    setInclusionUploadFile(file);
    setInclusionUploadPreview(URL.createObjectURL(file));
    setShowInclusionWebcam(false);
    setInclusionCameraError('');
  };

  const cancelInclusionWebcam = () => {
    setShowInclusionWebcam(false);
    setInclusionCameraError('');
  };

  const handleBackToInclusionForm = () => {
    setInclusionWizardStep(1);
    setShowInclusionWebcam(false);
    setInclusionCameraError('');
  };

  const handleFinalizeInclusionWizard = async () => {
    if (!internalId) {
      toast.error('Nenhum interno selecionado.');
      return;
    }

    if (!validateLocationSelection(inclusionFormData)) return;

    if (!inclusionUploadFile) {
      toast.error('Envie o arquivo assinado.');
      return;
    }

    const isValidFile = Boolean(
      inclusionUploadFile && (
        (typeof window.File === 'function' && inclusionUploadFile instanceof window.File)
        || (typeof window.Blob === 'function' && inclusionUploadFile instanceof window.Blob)
      )
    );
    if (!isValidFile) {
      toast.error('Arquivo inválido. Selecione novamente.');
      return;
    }

    const writeUnit = requireWriteUnit();
    if (!writeUnit.ok) {
      toast.warning(writeUnit.message);
      return;
    }

    const formData = new FormData();
    formData.append('internal', String(internalId));
    formData.append('unit', String(writeUnit.unitId));

    const numberFields = new Set(['age']);
    Object.entries(inclusionFormData).forEach(([key, value]) => {
      let nextValue = value;
      if (Array.isArray(nextValue)) {
        nextValue = nextValue[0];
      }

      if (inclusionBooleanFields.has(key)) {
        formData.append(key, nextValue ? 'true' : 'false');
        return;
      }

      if (key === 'cpf') {
        const cpfDigits = normalizeCpfDigits(nextValue);
        // Só envia o CPF se estiver preenchido; campo vazio causa erro no backend.
        if (cpfDigits) {
          formData.append('cpf', `"${cpfDigits}"`);
        }
        return;
      }

      if (key === 'naturalness_city') {
        // Só envia quando uma cidade foi escolhida na lista (ID)
        if (nextValue) {
          formData.append(key, String(nextValue));
        }
        return;
      }

      if (numberFields.has(key)) {
        if (nextValue === '' || nextValue === null || nextValue === undefined) {
          formData.append(key, '');
        } else {
          formData.append(key, String(Number(nextValue)));
        }
        return;
      }

      if (key === 'inclusion_date' && typeof nextValue === 'string') {
        nextValue = `${nextValue.slice(0, 10)}T12:00:00`;
      }

      formData.append(key, nextValue === null || nextValue === undefined ? '' : String(nextValue));
    });

    formData.append('file', inclusionUploadFile);

    setIsSavingInclusion(true);
    try {
      const response = inclusionFormId
        ? await updateInternalInclusion(inclusionFormId, formData)
        : await createInternalInclusion(formData);

      if (!response) return;

      await fetchInclusionList();
      handleCloseInclusionWizard();
    } catch (error) {
      console.error('Erro ao salvar ficha de inclusão no detalhe do interno:', error);
    } finally {
      setIsSavingInclusion(false);
    }
  };


  // // Formata as sentenças de prisão
  // const formatSentence = (sentence) => {
  //   if (!sentence) return '';
  //   const { years, months, days } = sentence;
  //   return `${years} anos, ${months} meses, ${days} dias`;
  // };

  const safeArray = (value, fieldName = '') => {
    if (Array.isArray(value)) return value;
    if (value === null || value === undefined) return [];
    if (fieldName) {
      console.warn(`[internalDetails] Campo esperado como lista: ${fieldName}`, value);
    }
    return [];
  };

  // Formata a data para o formato brasileiro
  const formatDate = (dateString, fallback = '-') => {
    if (!dateString) return fallback;
    const parsedDate = new Date(dateString);
    if (Number.isNaN(parsedDate.getTime())) {
      return fallback;
    }
    return parsedDate.toLocaleDateString('pt-BR');
  };

  const formatDateTime = (dateString, fallback = '-') => {
    if (!dateString) return fallback;
    const parsedDate = new Date(dateString);
    if (Number.isNaN(parsedDate.getTime())) {
      return fallback;
    }
    return parsedDate.toLocaleString('pt-BR');
  };

  // Formata o CPF
  const formatCPF = (cpf) => {
    if (!cpf) return '';
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  };

  const formatYesNo = (value) => (value ? 'Sim' : 'Não');

  const formatListNames = (items, fallback = 'Nenhum') => {
    if (!Array.isArray(items) || items.length === 0) return fallback;
    return items
      .map((item) => {
        if (typeof item === 'string' || typeof item === 'number') return String(item);
        if (!item || typeof item !== 'object') return null;
        return item.name || item.description || item.title || item.type || item.social_name || (item.id ? `ID ${item.id}` : null);
      })
      .filter(Boolean)
      .join(', ');
  };

  const formatTypeVisitors = (typeVisitors) => {
    if (!Array.isArray(typeVisitors) || typeVisitors.length === 0) return '-';
    const labels = typeVisitors
      .map((item) => item?.name || item?.type || '')
      .filter(Boolean);
    return labels.length ? labels.join(', ') : '-';
  };

  const getRelationshipWithCurrentInternal = (visitor) => {
    const internals = Array.isArray(visitor?.internals) ? visitor.internals : [];
    const currentInternal = internals.find((item) => String(item?.id) === String(internalId));
    return (
      currentInternal?.relationship
      || currentInternal?.type_relationship
      || currentInternal?.type_relationship_name
      || '-'
    );
  };

  const getVisitorEntryAuthorizationLabel = (visitor) => {
    if (visitor?.authorize_entry === true) return 'Autorizado';
    if (visitor?.authorize_entry === false) return 'Não autorizado';
    return '-';
  };

  const formatFactionValue = (value, fallback = '-') => {
    if (!value) return fallback;
    if (typeof value === 'string' || typeof value === 'number') return String(value);
    if (typeof value === 'object') {
      return value.name || value.relationship || value.type || value.title || (value.id ? `ID ${value.id}` : fallback);
    }
    return fallback;
  };

  const formatFactionGodparents = (value, fallback = '-') => {
    if (!Array.isArray(value) || value.length === 0) return fallback;
    const labels = value
      .map((item) => {
        if (typeof item === 'string' || typeof item === 'number') return String(item);
        return item?.name || item?.social_name || (item?.id ? `ID ${item.id}` : null);
      })
      .filter(Boolean);
    return labels.length > 0 ? labels.join(', ') : fallback;
  };

  const formatValue = (value, fallback = '-') => {
    if (value === 0) return '0';
    return value ? value : fallback;
  };

  const getLeavingRecordStatus = (record) => {
    if (record?.returned) {
      return { label: 'Retornado', className: 'returned' };
    }
    if (record?.active) {
      return { label: 'Saída Ativa', className: 'active' };
    }
    return { label: 'Finalizado', className: 'inactive' };
  };

  const formatPrescriptionLine = (item) => {
    const name = item?.name || '-';
    const dosage = item?.dosage || '-';
    const frequency = item?.frequency || '-';
    const local = item?.local ? ` • Local: ${item.local}` : '';
    return `${name} • Dosagem: ${dosage} • Frequência: ${frequency}${local}`;
  };

  const formatForwardingLine = (item) => {
    const expertise = item?.expertise?.name || '-';
    const regulation = item?.regulation || '-';
    const reason = item?.reason || item?.observation || '-';
    return `${expertise} • Regulação: ${regulation} • Observação: ${reason}`;
  };




  // Retorna a classe CSS para a conduta
  const getConductColor = (conduct_name) => {
    if (conduct_name === 'Bom') {
      return 'green-text';
    } else if (conduct_name === 'Normal') {
      return 'blue-text';
    } else if (conduct_name === 'Ruim') {
      return 'red-text';
    } else {
      return '';
    }
  };

  // Retorna a classe CSS para o status
  const getStatusColor = (status) => {
    if (status === 'Preso') {
      return 'red-text';
    } else if (status === 'Fugitivo') {
      return 'orange-text';
    } else if (status === 'Liberado') {
      return 'green-text';
    } else if (status === 'Monitorado') {
      return 'blue-text';
    } else if (status === 'Saída Temporária' || status === 'Saida Temporaria') {
      return 'purple-text';
    } else {
      return '';
    }
  };

  const EMPTY_ACCORDION_MESSAGE = 'Nenhum dado a ser mostrado por aqui';

  const renderAccordionEmptyState = (className = '') => (
    <p className={`semDados accordion-empty-state ${className}`.trim()}>
      {EMPTY_ACCORDION_MESSAGE}
    </p>
  );

  const hasEducationData = [
    internalEducations,
    receptionEducations,
    educationEvolutions,
    readings,
    enrollments,
    scores,
    frequencies,
    listFinalResultsData,
    ibraemaLiteracy,
  ].some((list) => Array.isArray(list) && list.length > 0);

  const arrivalDateFormatted = formatDate(internalDetails?.arrival, 'Não informado');

  const formatDateInputValue = (value) => {
    if (!value) return '';
    return String(value).split('T')[0];
  };

  const handleOpenArrivalDateModal = async () => {
    setArrivalDateForm(formatDateInputValue(internalDetails?.arrival));
    setArrivalEditTarget(null);
    setShowArrivalDateModal(true);
    setIsLoadingArrivalTarget(true);

    try {
      const res = await listTransfers({ internal: internalId, limit: 50 });
      const receivedTransfers = (res?.results || [])
        .filter((t) => t.received === true)
        .sort((a, b) => new Date(b.date_recipient || b.date) - new Date(a.date_recipient || a.date) || b.id - a.id);
      const latestReceived = receivedTransfers[0] || null;

      if (latestReceived) {
        setArrivalEditTarget({ type: 'transfer', id: latestReceived.id });
      } else {
        const currentCycle = cicles.find((c) => c?.open === true) || cicles[0] || null;
        setArrivalEditTarget(currentCycle ? { type: 'cycle', id: currentCycle.id } : null);
      }
    } catch (error) {
      console.error('Erro ao identificar origem da data de entrada:', error);
    } finally {
      setIsLoadingArrivalTarget(false);
    }
  };

  const handleCloseArrivalDateModal = () => {
    if (isSavingArrivalDate) return;

    setShowArrivalDateModal(false);
    setArrivalDateForm('');
    setArrivalEditTarget(null);
  };

  const handleSaveArrivalDate = async () => {
    if (!arrivalDateForm) {
      toast.error('Informe a nova data de entrada.');
      return;
    }
    if (!arrivalEditTarget) {
      toast.error('Não foi possível localizar o ciclo ou a transferência para atualizar.');
      return;
    }

    setIsSavingArrivalDate(true);

    try {
      const response = arrivalEditTarget.type === 'transfer'
        ? await updateTransfer(arrivalEditTarget.id, { date_recipient: arrivalDateForm })
        : await updateCicle(arrivalEditTarget.id, { start_date: `${arrivalDateForm}T12:00:00` });

      if (!response) return;

      setShowArrivalDateModal(false);
      setArrivalDateForm('');
      setArrivalEditTarget(null);

      await fetchInternalDetails();
      await fetchCicles();
    } catch (error) {
      console.error('Erro ao salvar data de entrada:', error);
    } finally {
      setIsSavingArrivalDate(false);
    }
  };

  const handleToggleVisit = async () => {
    if (isTogglingVisit) return;
    setIsTogglingVisit(true);
    try {
      const newValue = !internalDetails.visit;
      await updateInternal(internalId, { visit: newValue });
      setInternalDetails((prev) => ({ ...prev, visit: newValue }));
    } catch (_) {
      // toast tratado no context
    } finally {
      setIsTogglingVisit(false);
    }
  };

  if (isLoadingDetails) {
    return (
      <div>
        <Sidebar />
        <Header />
        <div className='container internal-details-page'>
          {Array.from({ length: 14 }).map((_, index) => (
            <div key={`accordion-skeleton-${index}`} className="content open">
              <Skeleton
                type="stack"
                lines={2}
                className="internal-accordion-skeleton"
                prefix={`internal-accordion-${index}`}
              />
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div>
      <Sidebar />
      <Header />
      <div className='container internal-details-page'>

        {/* Acordeon dados gerais*/}
        <div className={`content ${accordionState.dadosGerais ? 'open' : ''}`}>
          <h4 className='h4-title title-accordion' onClick={() => toggleAccordion('dadosGerais')}>
            Dados do Interno <FontAwesomeIcon className='icon-accordion' icon={accordionState.dadosGerais ? faChevronRight : faChevronDown} />
          </h4>

          {/* Aviso de vínculo entre cadastros */}
          {internalDetails && internalDetails.other ? (
            <>
              <div className={`other-internal ${internalDetails.main ? 'other-internal--green' : ''}`}>
                {internalDetails.main ? (
                  <Link to={`/internos/${internalDetails.other}`}>
                    Este interno possui um cadastro secundário vinculado. <strong>Clique aqui para Visualizar</strong>.
                  </Link>
                ) : (
                  <Link to={`/internos/${internalDetails.other}`}>
                    Interno possui outro cadastro principal. <strong>Clique aqui para Visualizar</strong>.
                  </Link>
                )}
              </div>
              {!internalDetails.main ? (
                <div className="other-internal-warning">
                  Atenção: este é um cadastro secundário. Todas as alterações de dados devem ser realizadas no <Link to={`/internos/${internalDetails.other}`}>cadastro principal</Link>.
                </div>
              ) : (
                <div className="other-internal-info">
                  Este é o cadastro principal. Utilize esta tela para manipular os dados do interno.
                </div>
              )}
            </>
          ) : null}


          {accordionState.dadosGerais ? (
            isLoadingDetails ? (
              <div className="internal-details">
                <Skeleton
                  type="stack"
                  lines={6}
                  text="Carregando dados do interno..."
                  className="internal-details-skeleton"
                  prefix="internal-details"
                />
              </div>
            ) : internalDetails ? (
              <div className="internal-details">
                <VisibleAccess compareField="unit" compareValues={[internalDetails ? internalDetails.unit : null]}>
                  <div className='content-btn-edit'>
                    <VisibleAccess compareField="groups" compareValues={["DISCIPLINA", "PLANTONISTA", "ADMINISTRATIVO", "MONITORAMENTO"]}>
                      <button onClick={handleEditInternal}>
                        <img src={Lapis} alt="Upload icon" className="upload-icon" />
                        Editar Interno
                      </button>
                    </VisibleAccess>
                  </div>
                </VisibleAccess>

                {/* Linha 1: Imagem, Primeiros Dados, Outros Dados */}
                <div className="line first-line">
                  <div className="profile-image-container">
                    {internalDetails.other ? (
                      <span className={`internal-type-flag ${internalDetails.main ? 'internal-type-flag--principal' : 'internal-type-flag--secundario'}`}>
                        {internalDetails.main ? 'Principal' : 'Secundário'}
                      </span>
                    ) : null}
                    <div className="profile-image-wrapper">
                      <InternalPhoto image={internalImage} alt='Foto interno' className="profile-image" />
                    </div>
                    <div className="arrival-meta-inline">
                      <div className="arrival-meta-content">
                        <FontAwesomeIcon icon={faCalendarDays} />
                        <div>
                          <span className="arrival-meta-label">Entrada na unidade</span>
                          <strong className="arrival-meta-date">{arrivalDateFormatted}</strong>
                          <VisibleAccess compareField="unit" compareValues={[internalDetails ? internalDetails.unit : null]}>
                            <VisibleAccess compareField="groups" compareValues={["DISCIPLINA", "PLANTONISTA", "ADMINISTRATIVO", "MONITORAMENTO"]}>
                              <button
                                type="button"
                                className="arrival-meta-edit-btn"
                                onClick={handleOpenArrivalDateModal}
                                title="Editar data de entrada"
                                aria-label="Editar data de entrada"
                              >
                                <FontAwesomeIcon icon={faPen} />
                              </button>
                            </VisibleAccess>
                          </VisibleAccess>
                        </div>
                      </div>


                      {showArrivalDateModal && (
                        <div className="arrival-date-popover">
                          <div className="arrival-date-popover-arrow" />

                          <div className="arrival-date-popover-header">
                            <strong>Editar entrada</strong>

                            <button
                              type="button"
                              className="arrival-date-popover-close"
                              onClick={handleCloseArrivalDateModal}
                              disabled={isSavingArrivalDate}
                              aria-label="Fechar edição de data de entrada"
                            >
                              ×
                            </button>
                          </div>

                          <div className="arrival-date-popover-body">
                            <label>Nova data de entrada</label>
                            <input
                              type="date"
                              value={arrivalDateForm}
                              onChange={(event) => setArrivalDateForm(event.target.value)}
                            />
                            <small style={{ display: 'block', marginTop: 4, color: '#6c757d' }}>
                              {isLoadingArrivalTarget
                                ? 'Identificando o que será atualizado...'
                                : arrivalEditTarget?.type === 'transfer'
                                  ? 'Isso vai atualizar a data de recebimento da transferência que trouxe o interno para esta unidade.'
                                  : arrivalEditTarget?.type === 'cycle'
                                    ? 'Isso vai atualizar a data de início do ciclo atual.'
                                    : 'Não foi possível localizar o ciclo ou a transferência para atualizar.'}
                            </small>
                          </div>

                          <div className="arrival-date-popover-actions">
                            <button
                              type="button"
                              className="arrival-date-cancel-btn"
                              onClick={handleCloseArrivalDateModal}
                              disabled={isSavingArrivalDate}
                            >
                              Fechar
                            </button>

                            <button
                              type="button"
                              className="arrival-date-save-btn"
                              onClick={handleSaveArrivalDate}
                              disabled={isSavingArrivalDate || isLoadingArrivalTarget || !arrivalEditTarget}
                            >
                              {isSavingArrivalDate ? 'Salvando...' : 'Salvar'}
                            </button>
                          </div>
                        </div>
                      )}
                    </div>

                    <VisibleAccess
                      compareField="unit"
                      compareValues={[internalDetails.unit]}
                      fallback={
                        <span className={`visit-flag ${internalDetails.visit ? 'visit-flag--liberado' : 'visit-flag--bloqueado'}`}>
                          {internalDetails.visit ? 'Visita liberada' : 'Visita bloqueada'}
                        </span>
                      }
                    >
                      <VisibleAccess
                        compareField="groups"
                        compareValues={["DISCIPLINA", "ADMINISTRATIVO"]}
                        fallback={
                          <span className={`visit-flag ${internalDetails.visit ? 'visit-flag--liberado' : 'visit-flag--bloqueado'}`}>
                            {internalDetails.visit ? 'Visita liberada' : 'Visita bloqueada'}
                          </span>
                        }
                      >
                        <button
                          type="button"
                          className={`visit-flag ${internalDetails.visit ? 'visit-flag--liberado' : 'visit-flag--bloqueado'}`}
                          onClick={handleToggleVisit}
                          disabled={isTogglingVisit}
                          title={internalDetails.visit ? 'Clique para bloquear visita' : 'Clique para liberar visita'}
                        >
                          {isTogglingVisit ? '...' : internalDetails.visit ? 'Visita liberada' : 'Visita bloqueada'}
                        </button>
                      </VisibleAccess>
                    </VisibleAccess>
                  </div>

                  <div className="basic-info">
                    <p><strong>Nome:</strong> {internalDetails.name}</p>
                    <p><strong>Vulgo:</strong> {formatListNames(safeArray(internalDetails.aka, 'internalDetails.aka'), '-')}</p>
                    <p><strong>CPF:</strong> {formatCPF(internalDetails.cpf)}</p>
                    <p><strong>Gênero:</strong> {internalDetails.gender?.name ?? internalDetails.gender ?? '-'}</p>
                    <p><strong>Cor etnia:</strong> {internalDetails.color_or_ethnicity?.name ?? internalDetails.color_or_ethnicity ?? '-'}</p>
                    <p><strong>Data de Nascimento:</strong> {formatDate(internalDetails.date_of_birth)}</p>
                  </div>

                  <div className="additional-info">
                    <p><strong>Identidade:</strong> {internalDetails.rg}</p>
                    <p><strong>Nome social:</strong> {internalDetails.social_name}</p>
                    <p><strong>Naturalidade:</strong> {internalDetails.naturalness_city}</p>
                    <p><strong>Nome da Mãe:</strong> {internalDetails.mothers_name}</p>
                    <p><strong>Estado Civil:</strong> {internalDetails.marital_status?.name ?? internalDetails.marital_status ?? '-'}</p>
                    <p><strong>RJI:</strong> {internalDetails.rji_biometrics}</p>
                  </div>
                </div>

                {/* Linha 2: Conduta, Status, Regime, Unidade, Pavilhão, Cela */}
                <div className="line second-line">
                  <div className={`status-box ${getConductColor(internalDetails.conduct?.name)}`}>
                    <strong>Conduta</strong>
                    <p>{internalDetails.conduct?.name || '-'}</p>
                  </div>
                  <div className={`status-box ${getStatusColor(internalDetails.status?.name)}`}>
                    <strong>Status</strong>
                    <p>{internalDetails.status?.name || '-'}</p>
                  </div>
                  <div className="status-box"><strong>Regime</strong><p>{internalDetails.regime || '-'}</p></div>
                  <div className="status-box"><strong>Natureza prisão</strong><p>{internalDetails.prison || '-'}</p></div>
                  <div className="status-box"><strong>Unidade</strong><p>{internalDetails.unit_acronym}</p></div>
                  <div className="status-box"><strong>Pavilhão</strong><p>{internalDetails.pavilion_name}</p></div>
                  <div className="status-box"><strong>Cela</strong><p>{internalDetails.cell_name}</p></div>
                  {/* <div className="status-box"><strong>CADASTRO</strong><p>{internalDetails.main ? 'Principal' : "Secundário"}</p></div> */}
                </div>


                <h4 className='h4-title' style={{ marginBottom: '-20px' }}>Dados de Facção</h4>
                <div className="line second-line">
                  <div className="status-box" ><strong>Facção</strong><p>{formatFactionValue(internalDetails.faction_relationship?.faction)}</p></div>
                  <div className="status-box"><strong>Relacionamento</strong><p>{formatFactionValue(internalDetails.faction_relationship?.relationship)}</p></div>
                </div>

                {/* Linha 3: Miniaturas de imagens e botão de adicionar */}
                <div className="line third-line">
                  <h3>Imagens anexadas</h3>
                  <div className="images-grid images-grid--captioned">
                    {internalImages.map((image) => {
                      const imageDetailType = image.detail_type?.trim() || '';
                      const imageDescription = image.description?.trim() || '';
                      return (
                        <div key={image.id} className="image-card">
                          <div className="image-thumbnail">
                            <BinaryImage
                              resource={BINARY_RESOURCES.internalImage}
                              id={image.id}
                              field={resolveThumbnailField(image)}
                              alt="Imagem do interno"
                              onClick={() => handleThumbnailClick(image.id, image.description, image.detail_type)}
                            />
                            <VisibleAccess compareField="groups" compareValues={["DISCIPLINA", "ADMINISTRATIVO", "MONITORAMENTO"]}>
                              <VisibleAccess compareField="unit" compareValues={[internalDetails ? internalDetails.unit : null]}>
                                <div className="image-actions-container">
                                  <button
                                    type="button"
                                    className={`image-main-btn image-main-icon-btn ${image.main ? 'is-main' : ''}`}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleSetMainImage(image.id);
                                    }}
                                    title={image.main ? 'Imagem principal' : 'Marcar como principal'}
                                    aria-label={image.main ? 'Imagem principal' : 'Marcar como principal'}
                                  >
                                    <FontAwesomeIcon icon={image.main ? faHeartSolid : faHeartRegular} />
                                  </button>
                                  <button
                                    type="button"
                                    className="image-delete-btn"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleDeleteImage(image.id);
                                    }}
                                    title="Remover imagem"
                                  >
                                    <FontAwesomeIcon icon={faTrash} />
                                  </button>
                                </div>
                              </VisibleAccess>
                            </VisibleAccess>
                          </div>
                          {/* Legenda: detalhe e descrição (2 linhas; texto completo no hover) ou aviso de vazio */}
                          <div
                            className="image-caption"
                            title={[imageDetailType, imageDescription].filter(Boolean).join('\n') || undefined}
                          >
                            <strong className={`image-caption-title${imageDetailType ? '' : ' is-empty'}`}>
                              {imageDetailType || 'Sem detalhes'}
                            </strong>
                            <span className={`image-caption-description${imageDescription ? '' : ' is-empty'}`}>
                              {imageDescription || 'Sem descrição'}
                            </span>
                          </div>
                        </div>
                      );
                    })}
                    <VisibleAccess compareField="unit" compareValues={[internalDetails ? internalDetails.unit : null]}>
                      <VisibleAccess compareField="groups" compareValues={["DISCIPLINA", "PLANTONISTA", "ADMINISTRATIVO", "MONITORAMENTO"]}>
                        <button className="add-image-btn" onClick={handleImageModal}>
                          <img src={ImgPlaceholder} alt="Upload icon" className="upload-icon" />
                        </button>
                      </VisibleAccess>
                    </VisibleAccess>
                  </div>
                </div>
              </div>
            ) : (
              <div className="internal-details">
                {renderAccordionEmptyState()}
              </div>
            )
          ) : null}
        </div>

        {/* Acordeon Disciplinas*/}
        <VisibleAccess compareField="groups" compareValues={["DISCIPLINA", "GERENTE DE UNIDADE", "DIRETORES", "DUAP"]}>
          <div className={`content ${accordionState.disciplina ? 'open' : ''}`}>
            <h4 className='h4-title title-accordion' onClick={() => toggleAccordion('disciplina')}>
              Notas/Faltas (Disciplina) <FontAwesomeIcon className='icon-accordion' icon={accordionState.disciplina ? faChevronRight : faChevronDown} />
            </h4>
            {accordionState.disciplina ? (
              internalDetails ? (
                <div>
                  <VisibleAccess compareField="groups" compareValues={["DISCIPLINA"]}>
                    <Discipline internalId={internalId} onUpdate={() => setRefreshDicipline(prev => prev + 1)} />
                  </VisibleAccess>

                  <div className='container-dicipline-time-line'>
                    {/* Exibe sempre a linha do tempo das Faltas Disciplinares */}
                    <div className="discipline-timeline">
                      <h3>Histórico de Faltas</h3>
                      {loadingFaults ? (
                        <p>Carregando...</p>
                      ) : faults.length > 0 ? (
                        <ul>
                          {[...faults].sort((a, b) => new Date(b.date) - new Date(a.date)).map((fault, index) => (
                            <li key={index} className="timeline-item-discipline">
                              <div className='timeline-dot-span'>
                                <div className="timeline-dot-discipline"></div>
                                <span className="timeline-date-discipline">{formatDateTime(fault.date)}</span>
                              </div>
                              <div className="timeline-content-discipline">
                                <strong>Falta Disciplinar</strong>
                                <div className="timeline-extra-info">
                                  <strong>Tipo:</strong>
                                  <span>{fault.disciplinary_fault_name || '-'}</span>
                                </div>
                                <div className="timeline-extra-info">
                                  <strong>Descrição:</strong>
                                  <span>{fault.notes || '-'}</span>
                                </div>
                              </div>
                            </li>
                          ))}
                        </ul>
                      ) : (
                        renderAccordionEmptyState()
                      )}
                    </div>

                    {/* Exibe sempre a linha do tempo das Notas Disciplinares */}
                    <div className="discipline-timeline">
                      <h3>Histórico de Notas</h3>
                      {loadingNotes ? (
                        <p>Carregando...</p>
                      ) : notesTimeline.length > 0 ? (
                        <ul>
                          {[...notesTimeline].sort((a, b) => new Date(b.date) - new Date(a.date)).map((note, index) => (
                            <li key={index} className="timeline-item-discipline">
                              <div className='timeline-dot-span'>
                                <div className="timeline-dot-discipline"></div>
                                <span className="timeline-date-discipline">{formatDateTime(note.date)}</span>
                              </div>
                              <div className="timeline-content-discipline">
                                <strong>Nota Interna</strong>
                                <p>{note.notes}</p>
                                {note.function && (
                                  <div className="timeline-extra-info">
                                    <strong>Função na unidade:</strong> <span>{note.function}</span>
                                  </div>
                                )}
                                {safeArray(note.partners_crime, 'note.partners_crime').length > 0 && (
                                  <div className="timeline-extra-info">
                                    <strong>Parceiros de Crime:</strong>
                                    <span>{formatListNames(safeArray(note.partners_crime, 'note.partners_crime'))}</span>
                                  </div>
                                )}
                                {safeArray(note.enemies, 'note.enemies').length > 0 && (
                                  <div className="timeline-extra-info">
                                    <strong>Inimigos:</strong>
                                    <span>{formatListNames(safeArray(note.enemies, 'note.enemies'))}</span>
                                  </div>
                                )}
                                {safeArray(note.signs, 'note.signs').length > 0 && (
                                  <div className="timeline-extra-info">
                                    <strong>Sinais Particulares:</strong>
                                    <span>{formatListNames(safeArray(note.signs, 'note.signs'))}</span>
                                  </div>
                                )}
                              </div>
                            </li>
                          ))}
                        </ul>
                      ) : (
                        renderAccordionEmptyState()
                      )}
                    </div>

                  </div>

                </div>
              ) : renderAccordionEmptyState()
            ) : null}
          </div>
        </VisibleAccess>

        {/* Facção */}
        <VisibleAccess compareField="groups" compareValues={["DISCIPLINA", "GERENTE DE UNIDADE", "DIRETORES", "DUAP"]}>
          <div className={`content ${accordionState.factionRelationship ? 'open' : ''}`}>
            <h4 className='h4-title title-accordion' onClick={() => toggleAccordion('factionRelationship')}>
              Relação Facção (Disciplina) <FontAwesomeIcon className='icon-accordion' icon={accordionState.factionRelationship ? faChevronRight : faChevronDown} />
            </h4>
            {accordionState.factionRelationship ? (
              internalDetails ? (
                <div>
                  <VisibleAccess
                    compareField="groups"
                    compareValues={["DISCIPLINA"]}
                    fallback={(
                      <div className="social-service-details">
                        <div>
                          <h5>Facção:</h5>
                          <p>{formatFactionValue(internalDetails?.faction_relationship?.faction)}</p>
                        </div>
                        <div>
                          <h5>Relacionamento:</h5>
                          <p>{formatFactionValue(internalDetails?.faction_relationship?.relationship)}</p>
                        </div>
                        <div>
                          <h5>Padrinhos:</h5>
                          <p>{formatFactionGodparents(internalDetails?.faction_relationship?.godparents)}</p>
                        </div>
                      </div>
                    )}
                  >
                    <div className=''>
                      <FactionRelationship
                        internalId={internalDetails?.id}
                        relationshipId={internalDetails?.faction_relationship?.id}
                      />
                    </div>
                  </VisibleAccess>

                </div>
              ) : renderAccordionEmptyState()
            ) : null}
          </div>
        </VisibleAccess>

        {/* Acordeon historico de cela do interno*/}
        <div className={`content ${accordionState.historico_cela ? 'open' : ''}`}>
          <h4 className='h4-title title-accordion' onClick={() => toggleAccordion('historico_cela')}>
            Mudanças de Cela<FontAwesomeIcon className='icon-accordion' icon={accordionState.historico_cela ? faChevronRight : faChevronDown} />
          </h4>
          {accordionState.historico_cela ? (
            internalDetails ? <CellMovements internalId={internalId} /> : renderAccordionEmptyState()
          ) : null}
        </div>

        {/* Acordeon histórico de saídas */}
        <div className={`content ${accordionState.historicoSaidas ? 'open' : ''}`}>
          <h4 className='h4-title title-accordion' onClick={() => toggleAccordion('historicoSaidas')}>
            Histórico de Saídas <FontAwesomeIcon className='icon-accordion' icon={accordionState.historicoSaidas ? faChevronRight : faChevronDown} />
          </h4>
          {accordionState.historicoSaidas ? (
            internalDetails ? (
              <div className='content-table'>
                {isLoadingTemporaryLeavingHistory ? (
                  <Skeleton
                    type="stack"
                    lines={3}
                    text="Carregando histórico de saídas..."
                    prefix="internal-leaving-history"
                  />
                ) : temporaryLeavingHistory.length > 0 ? (
                  <table>
                    <thead>
                      <tr>
                        <th>Tipo</th>
                        <th>Data da saída</th>
                        <th>Data do retorno</th>
                        <th>Status</th>
                        <th>Documento</th>
                      </tr>
                    </thead>
                    <tbody>
                      {temporaryLeavingHistory.map((record) => {
                        const status = getLeavingRecordStatus(record);
                        return (
                          <tr key={record?.id || `${record?.internal || 'record'}-${record?.leaving_date || ''}`}>
                            <td>{record?.type_leaving_name
                              || '-'}</td>
                            <td>{formatDate(record?.leaving_date)}</td>
                            <td>{formatDate(record?.return_date, 'Sem retorno')}</td>
                            <td>
                              <span className={`temporary-leaving-status ${status.className}`}>
                                {status.label}
                              </span>
                            </td>
                            <td>
                              {hasBinaryField(record, 'file') ? (
                                <BinaryFileLink resource={BINARY_RESOURCES.leavingRecord} id={record.id} field="file" className='btnEditar' title='Visualizar documento'>
                                  <FontAwesomeIcon icon={faFileAlt} />
                                </BinaryFileLink>
                              ) : (
                                '-'
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                ) : (
                  renderAccordionEmptyState()
                )}
              </div>
            ) : renderAccordionEmptyState()
          ) : null}
        </div>

        {/* Acordeon histórico de visitas recebidas (todas as unidades) */}
        <div className={`content ${accordionState.historicoVisitas ? 'open' : ''}`}>
          <h4 className='h4-title title-accordion' onClick={() => toggleAccordion('historicoVisitas')}>
            Histórico de Visitas <FontAwesomeIcon className='icon-accordion' icon={accordionState.historicoVisitas ? faChevronRight : faChevronDown} />
          </h4>
          {accordionState.historicoVisitas ? (
            internalDetails ? (
              <div className="discipline-timeline visit-history-timeline">
                {isLoadingVisitHistory ? (
                  <Skeleton
                    type="stack"
                    lines={3}
                    text="Carregando histórico de visitas..."
                    prefix="internal-visit-history"
                  />
                ) : visitHistory.length > 0 ? (
                  <ul>
                    {visitHistory.map((visit) => (
                      <li key={visit?.id} className="timeline-item-discipline">
                        <div className='timeline-dot-span'>
                          <div className="timeline-dot-discipline"></div>
                          <span className="timeline-date-discipline">{formatDateTime(visit?.date)}</span>
                        </div>
                        <div className="timeline-content-discipline">
                          <strong>Visitante:</strong> <span>{visit?.visitor_name || 'Não Informado'}</span>
                          <strong>Tipo de visita:</strong> <span>{visit?.type_visit_name || visit?.purpose_visit || 'Não Informado'}</span>
                          <strong>Unidade:</strong> <span>{visit?.unit_name || 'Não Informado'}</span>
                        </div>
                      </li>
                    ))}
                  </ul>
                ) : (
                  renderAccordionEmptyState()
                )}
              </div>
            ) : renderAccordionEmptyState()
          ) : null}
        </div>

        {/* Acordeon histórico de transferências */}
        <div className={`content ${accordionState.historicoTransferencias ? 'open' : ''}`}>
          <h4 className='h4-title title-accordion' onClick={() => toggleAccordion('historicoTransferencias')}>
            Histórico de Transferências <FontAwesomeIcon className='icon-accordion' icon={accordionState.historicoTransferencias ? faChevronRight : faChevronDown} />
          </h4>
          {accordionState.historicoTransferencias ? (
            internalDetails ? (
              <div className='content-table'>
                {isLoadingTransfers ? (
                  <Skeleton
                    type="stack"
                    lines={3}
                    text="Carregando histórico de transferências..."
                    prefix="internal-transfers-history"
                  />
                ) : internalTransfers.length > 0 ? (
                  <table>
                    <thead>
                      <tr>
                        <th>Unidade de origem</th>
                        <th>Unidade de destino</th>
                        <th>Status</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {internalTransfers.map((transfer) => {
                        let statusLabel = '';
                        let statusClass = '';
                        if ((transfer.is_active === 1 || transfer.is_active === true) && !transfer.received) {
                          statusLabel = 'Pendente'; statusClass = 'status-vermelho';
                        } else if ((transfer.is_active === 0 || transfer.is_active === false) && transfer.received) {
                          statusLabel = 'Realizada'; statusClass = 'status-verde';
                        } else if ((transfer.is_active === 0 || transfer.is_active === false) && !transfer.received && transfer.no_receipt) {
                          statusLabel = 'Recusada'; statusClass = 'status-amarelo';
                        } else if ((transfer.is_active === 0 || transfer.is_active === false) && !transfer.received && !transfer.no_receipt) {
                          statusLabel = 'Cancelada'; statusClass = 'status-azul';
                        }
                        return (
                          <tr key={transfer.id}>
                            <td className='td-limited'>{transfer.sender_name || '-'}</td>
                            <td className='td-limited'>{transfer.recipient_name || '-'}</td>
                            <td>
                              {statusLabel && <span className={statusClass}>{statusLabel}</span>}
                            </td>
                            <td className="td-table-icon">
                              <button
                                type="button"
                                className="btnEditar"
                                title="Ver detalhes"
                                onClick={() => { setSelectedTransferDetail(transfer); setIsTransferDetailModalOpen(true); }}
                              >
                                <FontAwesomeIcon icon={faEye} />
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                ) : (
                  renderAccordionEmptyState()
                )}
              </div>
            ) : renderAccordionEmptyState()
          ) : null}
        </div>

        {/* Acordeon endereços */}
        <div className={`content ${accordionState.enderecos ? 'open' : ''}`}>
          <h4 className='h4-title title-accordion' onClick={() => toggleAccordion('enderecos')}>
            Endereços <FontAwesomeIcon className='icon-accordion' icon={accordionState.enderecos ? faChevronRight : faChevronDown} />
          </h4>
          {accordionState.enderecos ? (
            internalDetails ? (
              <div>
                <VisibleAccess compareField="groups" compareValues={["DISCIPLINA", "ADMINISTRATIVO", "MONITORAMENTO"]}>
                  <div className='container-visibledAccess'>
                    <VisibleAccess compareField="unit" compareValues={[internalDetails ? internalDetails.unit : null]}>
                      <button className='btnAdcionar' onClick={handleAddAddress}>
                        <img src={PlusCircle} alt='Incone' />
                        Adicionar novo
                      </button>
                    </VisibleAccess>
                  </div>
                </VisibleAccess>
                <div className='content-table'>
                  {internalAddress.length > 0 ? (
                    <table>
                      <thead>
                        <tr>
                          <th>País</th>
                          <th>Estado</th>
                          <th>Cidade</th>
                          <th>Bairro</th>
                          <th>principal</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {internalAddress.map((address) => (
                          <tr key={address.id}>
                            <td>{address.country}</td>
                            <td>{address.state}</td>
                            <td>{address.city}</td>
                            <td className='td-limited'>{address.neighborhood}</td>
                            <td>{address.main === true ? 'Sim' : 'Não'}</td>
                            <td>
                              <VisibleAccess compareField="groups" compareValues={["DISCIPLINA", "ADMINISTRATIVO", "MONITORAMENTO"]}>
                                <VisibleAccess
                                  compareField="unit"
                                  compareValues={[internalDetails ? internalDetails.unit : null]}
                                  fallback={<span className='btnEditar'><FontAwesomeIcon icon={faEye} /></span>}
                                >
                                  <button onClick={() => handleEditAddress(address)} className='btnEditar'>
                                    <FontAwesomeIcon icon={faPencilAlt} />
                                  </button>
                                </VisibleAccess>
                              </VisibleAccess>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    renderAccordionEmptyState()
                  )}
                </div>
              </div>
            ) : renderAccordionEmptyState()
          ) : null}
        </div>

        {/* Acordeon contatos */}
        <div className={`content ${accordionState.contatos ? 'open' : ''}`}>
          <h4 className='h4-title title-accordion' onClick={() => toggleAccordion('contatos')}>
            Contatos <FontAwesomeIcon className='icon-accordion' icon={accordionState.contatos ? faChevronRight : faChevronDown} />
          </h4>
          {accordionState.contatos ? (
            internalDetails ? (
              <div>
                <InternalPhone internalId={internalId} internalUnit={internalDetails.unit} />
              </div>
            ) : renderAccordionEmptyState()
          ) : null}
        </div>

        {/* Acordeon documentos */}
        <div className={`content ${accordionState.documentos ? 'open' : ''}`}>
          <h4 className='h4-title title-accordion' onClick={() => toggleAccordion('documentos')}>
            Documentos <FontAwesomeIcon className='icon-accordion' icon={accordionState.documentos ? faChevronRight : faChevronDown} />
          </h4>
          {accordionState.documentos ? (
            internalDetails ? (
              <div>
                <div className='container-visibledAccess'>
                  <VisibleAccess compareField="unit" compareValues={[internalDetails ? internalDetails.unit : null]}>
                    <button className='btnAdcionar' onClick={handleAddFile}>
                      <img src={PlusCircle} alt='Incone' />
                      Adicionar novo
                    </button>
                  </VisibleAccess>
                </div>
                <div className='content-table'>
                  {files.length > 0 ? (
                    <table>
                      <thead>
                        <tr>
                          <th>Data</th>
                          <th>Tipo</th>
                          <th>Descrição</th>
                          <th>Processo</th>
                          <th style={{ textAlign: 'center' }}>Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        {files.map((file) => (
                          <tr key={file.id}>
                            <td>{formatDate(file.date)}</td>
                            <td>{safeArray(file.type, 'file.type').length > 0 ? (
                              safeArray(file.type, 'file.type').map((type, idx) => (
                                <div key={idx}>{type?.type || type?.name || String(type || '-')}</div>
                              ))
                            ) : (
                              '-'
                            )}</td>
                            <td className="doc-description">{file.description || '-'}</td>
                            <td>{file.process ? (processesMap[file.process] || `#${file.process}`) : '-'}</td>
                            <td style={{ textAlign: 'center' }}>
                              <FontAwesomeIcon
                                className='icoFile'
                                icon={faFileAlt}
                                onClick={() => openBinaryFile({ resource: BINARY_RESOURCES.internalFile, id: file.id, field: 'file' })}
                              />
                              <VisibleAccess compareField="groups" compareValues={["DISCIPLINA", "ADMINISTRATIVO", "MONITORAMENTO"]}>
                                <VisibleAccess compareField="unit" compareValues={[internalDetails ? internalDetails.unit : null]}>
                                  <button
                                    type="button"
                                    className="btn-delete-icon"
                                    onClick={() => handleDeleteFile(file.id)}
                                    title="Remover documento"
                                  >
                                    <FontAwesomeIcon icon={faTrash} />
                                  </button>
                                </VisibleAccess>
                              </VisibleAccess>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    renderAccordionEmptyState()
                  )}
                </div>
              </div>
            ) : renderAccordionEmptyState()
          ) : null}
        </div>

        {/* Acordeon ficha de inclusão */}
        <div className={`content ${accordionState.inclusao ? 'open' : ''}`}>
          <h4 className='h4-title title-accordion' onClick={() => toggleAccordion('inclusao')}>
            Ficha de Inclusão <FontAwesomeIcon className='icon-accordion' icon={accordionState.inclusao ? faChevronRight : faChevronDown} />
          </h4>
          {accordionState.inclusao ? (
            <div>
              <VisibleAccess compareField="groups" compareValues={["DISCIPLINA", "PLANTONISTA", "ADMINISTRATIVO", "MONITORAMENTO"]}>
                <div className='container-visibledAccess'>
                  <VisibleAccess compareField="unit" compareValues={[internalDetails ? internalDetails.unit : null]}>
                    <button className='btnAdcionar' onClick={() => handleOpenInclusionWizard()}>
                      <img src={PlusCircle} alt='Incone' />
                      Nova ficha de inclusão
                    </button>
                  </VisibleAccess>
                </div>
              </VisibleAccess>

              {inclusionList.length > 0 ? (
                <div className="inclusion-timeline">
                  {inclusionList.map((item) => {
                    const unitId = item?.unit?.id ?? item?.unit;
                    const unitFromMap = unitsMap[unitId];
                    const unitName = item.unit?.name
                      || item.unit?.acronym
                      || unitFromMap?.name
                      || unitFromMap?.acronym
                      || unitId
                      || 'Nenhuma unidade informada';
                    return (
                      <div
                        key={item.id}
                        role="button"
                        tabIndex={0}
                        className="inclusion-timeline-item"
                        onClick={() => handleOpenInclusionWizard(item)}
                        onKeyDown={(event) => {
                          if (event.key === 'Enter' || event.key === ' ') {
                            event.preventDefault();
                            handleOpenInclusionWizard(item);
                          }
                        }}
                      >
                        <div className="inclusion-timeline-date">{formatInclusionDate(item.inclusion_date || item.created_at)}</div>
                        <div className="inclusion-timeline-meta">
                          <span>{unitName}</span>
                          <button
                            type="button"
                            className="btn-secondary inclusion-quick-view-btn"
                            onClick={(event) => {
                              event.stopPropagation();
                              handleOpenInclusionDrawer(item);
                            }}
                          >
                            Visualizar
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                renderAccordionEmptyState()
              )}
            </div>
          ) : null}
        </div>

        {/* Acordeon Processos / Execução Penal */}
        <div className={`content ${accordionState.processos ? 'open' : ''}`}>
          <h4 className='h4-title title-accordion' onClick={() => toggleAccordion('processos')}>
            Processos / Execução Penal <FontAwesomeIcon className='icon-accordion' icon={accordionState.processos ? faChevronRight : faChevronDown} />
          </h4>
          {accordionState.processos ? (
            internalDetails ? (
              <ProcessAndExecutionTabs
                internalId={internalId}
                internalDetails={internalDetails}
              />
            ) : renderAccordionEmptyState()
          ) : null}
        </div>

        {/* Acordeon ciclos*/}
        <div className={`content ${accordionState.ciclos ? 'open' : ''}`}>
          <h4 className='h4-title title-accordion' onClick={() => toggleAccordion('ciclos')}>
            Ciclos <FontAwesomeIcon className='icon-accordion' icon={accordionState.ciclos ? faChevronRight : faChevronDown} />
          </h4>
          {accordionState.ciclos ? (
            internalDetails ? (
              <div>
                <div className='content-table'>
                  {cicles.length > 0 ? (
                    <table>
                      <thead>
                        <tr>
                          <th>Regime</th>
                          <th>Em aberto</th>
                          <th>Data inicial</th>
                          <th>Data pausa</th>
                          <th>Data final</th>
                        </tr>
                      </thead>
                      <tbody>
                        {cicles.map((cicle) => (
                          <tr key={cicle.id}>
                            <td>{cicle.regime_name}</td>
                            <td>{cicle.open ? 'Sim' : 'Não'}</td>
                            <td>{cicle.start_date ? formatDate(cicle.start_date) : 'N/A'}</td>
                            <td>{cicle.pause_date ? formatDate(cicle.pause_date) : 'N/A'}</td>
                            <td>{cicle.end_date ? formatDate(cicle.end_date) : 'N/A'}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    renderAccordionEmptyState()
                  )}
                </div>
              </div>
            ) : renderAccordionEmptyState()
          ) : null}
        </div>

        {/* Acordeon Serviço Social */}
        <div className={`content ${accordionState.servicoSocial ? 'open' : ''}`}>
          <h4 className='h4-title title-accordion' onClick={() => toggleAccordion('servicoSocial')}>
            Serviço Social <FontAwesomeIcon className='icon-accordion' icon={accordionState.servicoSocial ? faChevronRight : faChevronDown} />
          </h4>
          {accordionState.servicoSocial ? (
            socialServiceData ? (
              <>
                <div className="social-service-details">
                  <div>
                    <div>
                      <h5>Pai Vivo:</h5>
                      <p>{socialServiceData.living_father ? 'Sim' : 'Não'}</p>
                    </div>
                    <div>
                      <h5>Mãe Viva:</h5>
                      <p>{socialServiceData.living_mother ? 'Sim' : 'Não'}</p>
                    </div>
                    <div>
                      <h5>Relacionamento Familiar:</h5>
                      <p>{socialServiceData.family_relationship}</p>
                    </div>
                    <div>
                      <h5>Pessoa na Família:</h5>
                      <p>{socialServiceData.person_in_family}</p>
                    </div>
                    <div>
                      <h5>Grau de Parentesco:</h5>
                      <p>{socialServiceData.degree_of_kinship}</p>
                    </div>
                    <div>
                      <h5>Contato da Pessoa na Família:</h5>
                      <p>{socialServiceData.contact_person_in_family}</p>
                    </div>
                    <div>
                      <h5>Observação sobre Relacionamento:</h5>
                      <p>{socialServiceData.observation_about_relationship}</p>
                    </div>
                    <div>
                      <h5>Documentos Possuídos:</h5>
                      <p>{formatListNames(safeArray(socialServiceData.documents_have_list, 'socialServiceData.documents_have_list'), 'Nenhum')}</p>
                    </div>
                  </div>

                  <h4 className='h4-title'>Socioeconômico</h4>
                  <div>
                    <div>
                      <h5>Religião:</h5>
                      <p>{socialServiceData.religion_name}</p>
                    </div>
                    <div>
                      <h5>Número de Filhos:</h5>
                      <p>{socialServiceData.number_of_children}</p>
                    </div>
                    <div>
                      <h5>Responsável por Crianças com Menos de 12 Anos:</h5>
                      <p>{socialServiceData.responsible_for_under_twelve ? 'Sim' : 'Não'}</p>
                    </div>
                    <div>
                      <h5>Responsável por Deficiente:</h5>
                      <p>{socialServiceData.responsible_for_disabled ? 'Sim' : 'Não'}</p>
                    </div>
                    <div>
                      <h5>Programa Social:</h5>
                      <p>{formatListNames(safeArray(socialServiceData.social_program_list, 'socialServiceData.social_program_list'), 'Nenhum')}</p>
                    </div>
                    <div>
                      <h5>Família em Programa Social:</h5>
                      <p>{formatListNames(safeArray(socialServiceData.family_in_social_program_list, 'socialServiceData.family_in_social_program_list'), 'Nenhum')}</p>
                    </div>
                    <div>
                      <h5>Auxílio Prisão:</h5>
                      <p>{socialServiceData.prison_aid ? 'Sim' : 'Não'}</p>
                    </div>
                    <div>
                      <h5>Posição Econômica na Família:</h5>
                      <p>{socialServiceData.economic_position_in_family}</p>
                    </div>
                    <div>
                      <h5>Responsável pela Família:</h5>
                      <p>{socialServiceData.responsible_family ? 'Sim' : 'Não'}</p>
                    </div>
                    <div>
                      <h5>Renda:</h5>
                      <span>{socialServiceData.income}</span>
                    </div>
                    <div>
                      <h5>Responsável Atual pela Família:</h5>
                      <p>{socialServiceData.currently_responsible_for_family}</p>
                    </div>
                    <div>
                      <h5>Em Situação de Rua:</h5>
                      <p>{socialServiceData.street_situation ? 'Sim' : 'Não'}</p>
                    </div>
                    <div>
                      <h5>Contato do Responsável Atual pela Família:</h5>
                      <p>{socialServiceData.contact_currently_responsible}</p>
                    </div>
                  </div>

                  <h4 className='h4-title'>Trabalho</h4>
                  <div>
                    <div>
                      <h5>Já Trabalhou:</h5>
                      <p>{socialServiceData.worked ? 'Sim' : 'Não'}</p>
                    </div>
                    <div>
                      <h5>Profissão:</h5>
                      <p>{formatListNames(safeArray(socialServiceData.profession_list, 'socialServiceData.profession_list'), 'Nenhuma')}</p>
                    </div>
                    <div>
                      <h5>Trabalha na Unidade:</h5>
                      <p>{socialServiceData.work_in_the_unit ? 'Sim' : 'Não'}</p>
                    </div>
                    <div>
                      <h5>Observação sobre Trabalho:</h5>
                      <p>{socialServiceData.observation_about_work}</p>
                    </div>

                    <div>
                      <h5>Síntese:</h5>
                      <p>{socialServiceData.synthesis}</p>
                    </div>
                  </div>

                  <div className='arquivo'>
                    <h5>Arquivo:</h5>
                    {hasBinaryField(socialServiceData, 'file') ? (
                      <BinaryFileLink resource={BINARY_RESOURCES.receptionSocialService} id={socialServiceData.id} field="file">
                        <img src={FileIcon} alt='Incone' /> ver
                      </BinaryFileLink>
                    ) : (
                      <span>Sem arquivo</span>
                    )}
                  </div>
                </div>
              </>
            ) : renderAccordionEmptyState()
          ) : null}

        </div>

        <div className={`content ${accordionState.education ? 'open' : ''}`}>
          <h4 className='h4-title title-accordion' onClick={() => toggleAccordion('education')}>
            Educação <FontAwesomeIcon className='icon-accordion' icon={accordionState.education ? faChevronRight : faChevronDown} />
          </h4>
          {accordionState.education ? (
            internalDetails ? (
              hasEducationData ? (
                <div>
                  <div className="social-service-details">
                    {internalEducations.length > 0 ? internalEducations.map((item, index) => (
                      <div key={index}>
                        <div>
                          <h5>Nível:</h5>
                          <p> {item.nivel}</p>
                        </div>
                      </div>
                    )) : <p>Nenhum registro de escolaridade.</p>}


                    <h4 className="h4-title">Recepção Educacional</h4>
                    {receptionEducations.length > 0 ? receptionEducations.map((item, index) => (
                      <div key={index}>
                        <div>
                          <h5>Local do último ano escolar:</h5>
                          <p>{item.location_last_school_year}</p>
                        </div>
                        <div>
                          <h5>Deseja continuar os estudos:</h5>
                          <p>{item.want_continue_studies ? 'Sim' : 'Não'}</p>
                        </div>
                        <div>
                          <h5>Fez ENCCEJA:</h5>
                          <p>{item.made_encceja ? 'Sim' : 'Não'}</p>
                        </div>
                        <div>
                          <h5>Fez ENEM:</h5>
                          <p>{item.made_enem ? 'Sim' : 'Não'}</p>
                        </div>
                        <div>
                          <h5>Já estudou em prisões anteriores:</h5>
                          <p>{item.studied_previous_prisons ? 'Sim' : 'Não'}</p>
                        </div>
                        <div>
                          <h5>Deseja fazer exames de certificação:</h5>
                          <p>{item.want_take_certification_exams ? 'Sim' : 'Não'}</p>
                        </div>
                        <div>
                          <h5>Deseja fazer ENEM:</h5>
                          <p>{item.want_take_enem ? 'Sim' : 'Não'}</p>
                        </div>
                        <div>
                          <h5>Participou de atividade complementar:</h5>
                          <p>{item.participated_complementary_educational_activity ? 'Sim' : 'Não'}</p>
                        </div>
                        <div>
                          <h5>Deseja participar de atividade complementar:</h5>
                          <p>{item.want_participate_complementary_educational_activity ? 'Sim' : 'Não'}</p>
                        </div>
                        <div>
                          <h5>Fez curso de formação profissional:</h5>
                          <p>{item.taken_professional_training_course ? 'Sim' : 'Não'}</p>
                        </div>
                        <div>
                          <h5>Deseja participar de curso profissionalizante:</h5>
                          <p>{item.want_participate_professional_training_course ? 'Sim' : 'Não'}</p>
                        </div>
                        <div>
                          <h5>Possui atendimento educacional especializado:</h5>
                          <p>{item.special_educational_support || 'Não informado'}</p>
                        </div>
                        <div>
                          <h5>Considerações:</h5>
                          <p>{item.internal_considerations}</p>
                        </div>
                        <div>
                          <h5>Síntese:</h5>
                          <p>{item.synthesis}</p>
                        </div>

                        <div className='arquivo'>
                          <h5>Arquivo:</h5>
                          {hasBinaryField(item, 'file') ? (
                            <BinaryFileLink resource={BINARY_RESOURCES.receptionEducational} id={item.id} field="file">
                              <img src={FileIcon} alt="Ícone" /> ver
                            </BinaryFileLink>
                          ) : (
                            <span>Sem arquivo</span>
                          )}
                        </div>

                      </div>
                    )) : <p>Nenhuma recepção educacional registrada.</p>}

                    <h4 className="h4-title">Evolução Educacional</h4>
                    {educationEvolutions.length > 0 ? educationEvolutions.map((item, index) => (
                      <div key={index}>
                        <div>
                          <h5>Data:</h5>
                          <p>{formatDate(item.date)}</p>
                        </div>
                        <div>
                          <h5>Observação:</h5>
                          <p>{item.data}</p>
                        </div>
                      </div>
                    )) : <p>Nenhuma evolução registrada.</p>}

                    <h4 className="h4-title">Leitura Livre</h4>
                    {readings.length > 0 ? readings.map((item, index) => (
                      <div key={index}>
                        <div>
                          <h5>Livro::</h5>
                          <p>{item.book_name}</p>
                        </div>
                        <div>
                          <h5>Data::</h5>
                          <p>{formatDate(item.date)}</p>
                        </div>
                      </div>
                    )) : <p>Nenhuma leitura registrada.</p>}

                    <h4 className="h4-title">Matrículas</h4>
                    {enrollments.length > 0 ? enrollments.map((item, index) => (
                      <div key={index}>
                        <div>
                          <h5>Turma:</h5>
                          <p>{item.class_name}</p>
                        </div>
                        <div>
                          <h5>Data de Início:</h5>
                          <p>{formatDate(item.start_date)}</p>
                        </div>
                        <div>
                          <h5>Data de Fim:</h5>
                          <p>{item.end_date ? formatDate(item.end_date) : 'Em andamento'}</p>
                        </div>
                      </div>
                    )) : <p>Nenhuma matrícula registrada.</p>}

                    <h4 className="h4-title">Notas</h4>
                    {scores.length > 0 ? scores.map((item, index) => (
                      <div key={index}>
                        <div>
                          <h5>Nota:</h5>
                          <p>{item.score}</p>
                        </div>
                        <div>
                          <h5>Disciplina:</h5>
                          <p>{item.subject_name}</p>
                        </div>
                        <div>
                          <h5>Data:</h5>
                          <p>{formatDate(item.date)}</p>
                        </div>
                      </div>
                    )) : <p>Nenhuma nota registrada.</p>}

                    <h4 className="h4-title">Frequências</h4>
                    {frequencies.length > 0 ? frequencies.map((item, index) => (
                      <div key={index}>
                        <div>
                          <h5>Data:</h5>
                          <p>{formatDate(item.date)}</p>
                        </div>
                        <div>
                          <h5>Disciplina:</h5>
                          <p>{item.subject_name}</p>
                        </div>
                        <div>
                          <h5>Presença:</h5>
                          <p>{item.presence}</p>
                        </div>
                        <div>
                          <h5>Faltas:</h5>
                          <p>{item.faults}</p>
                        </div>

                      </div>
                    )) : <p>Nenhuma frequência registrada.</p>}

                    <h4 className="h4-title">Resultados Finais</h4>
                    {listFinalResultsData.length > 0 ? listFinalResultsData.map((item, index) => (
                      <div key={index}>
                        <div>
                          <h5>Data:</h5>
                          <p>{formatDate(item.date)}</p>
                        </div>
                        <div>
                          <h5>Aprovação:</h5>
                          <p>{item.approved}</p>
                        </div>
                        <div>
                          <h5>Disciplina:</h5>
                          <p>{item.subject_name}</p>
                        </div>
                        <div>
                          <h5>Observação:</h5>
                          <p>{item.observation}</p>
                        </div>
                      </div>
                    )) : <p>Nenhum resultado final registrado.</p>}

                    <h4 className="h4-title">Alfabetização Ibraema</h4>
                    {ibraemaLiteracy.length > 0 ? ibraemaLiteracy.map((item, index) => (
                      <div key={index}>
                        <div>
                          <h5>Data início:</h5>
                          <p>{formatDate(item.start)}</p>
                        </div>
                        <div>
                          <h5>Data fim:</h5>
                          <p>{formatDate(item.end)}</p>
                        </div>
                        <div>
                          <h5>Curso:</h5>
                          <p>{item.course}</p>
                        </div>
                        <div>
                          <h5>Unidade:</h5>
                          <p>{item.unit}</p>
                        </div>
                        <div>
                          <h5>Carga horária:</h5>
                          <p>{item.workload}</p>
                        </div>

                      </div>
                    )) : <p>Nenhum dado de alfabetização registrado.</p>}
                  </div>
                </div>
              ) : renderAccordionEmptyState()
            ) : renderAccordionEmptyState()
          ) : null}
        </div>

        {/* Acordeon de Trabalho */}
        <div className={`content content--trabalho ${accordionState.trabalho ? 'open' : ''}`}>
          <h4 className='h4-title title-accordion' onClick={() => toggleAccordion('trabalho')}>
            Trabalho <FontAwesomeIcon className='icon-accordion' icon={accordionState.trabalho ? faChevronRight : faChevronDown} />
          </h4>
          {accordionState.trabalho ? (
            isLoadingWorks ? (
              <p style={{ color: '#888', padding: '12px 0' }}>Carregando atividades laborais...</p>
            ) : internalWorks.length > 0 ? (
              <div className="work-timeline">
                {internalWorks.map((work) => {
                  const isActive = !work.end_date;
                  const launches = workLaunchesMap[work.id] || [];
                  const totalDias = launches.reduce((acc, l) => acc + (l.total_worked_days ?? 0), 0);

                  return (
                    <div key={work.id} className="work-timeline-item">
                      <div className={`work-timeline-dot${isActive ? ' work-timeline-dot--active' : ''}`} />
                      <div className="work-timeline-card">
                        <div className="work-card-header">
                          <div className="work-card-dates">
                            {formatDate(work.start_date)} até {work.end_date ? formatDate(work.end_date) : 'Atual'}
                          </div>
                          <div className="work-card-badges">
                            <span className={`work-badge ${isActive ? 'work-badge--active' : 'work-badge--closed'}`}>
                              {isActive ? 'Em andamento' : 'Encerrado'}
                            </span>
                            {totalDias > 0 && (
                              <span className="work-badge work-badge--days">
                                {totalDias} {totalDias === 1 ? 'dia trabalhado' : 'dias trabalhados'}
                              </span>
                            )}
                          </div>
                        </div>

                        <div className="work-card-grid">
                          <div className="work-card-field">
                            <span className="work-card-field-label">Tipo</span>
                            <span className="work-card-field-value">{work.type_work || '-'}</span>
                          </div>
                          <div className="work-card-field">
                            <span className="work-card-field-label">Carga Horária</span>
                            <span className="work-card-field-value">
                              {work.workload_hours ? `${work.workload_hours}h/sem` : '-'}
                            </span>
                          </div>
                          <div className="work-card-field">
                            <span className="work-card-field-label">Setor</span>
                            <span className="work-card-field-value">{work.sector || '-'}</span>
                          </div>
                          <div className="work-card-field">
                            <span className="work-card-field-label">Remuneração</span>
                            <span className="work-card-field-value">
                              {work.payment_type === 'Remissão' ? 'Remição' : (work.payment_type || '-')}
                            </span>
                          </div>
                          <div className="work-card-field">
                            <span className="work-card-field-label">
                              {work.payment_type === 'Remissão' ? 'Local' : 'Empresa'}
                            </span>
                            <span className="work-card-field-value">
                              {work.payment_type === 'Remissão'
                                ? (work.location_name || '-')
                                : (work.firm_name || '-')}
                            </span>
                          </div>
                          <div className="work-card-field work-card-field--full">
                            <span className="work-card-field-label">Função</span>
                            <span className="work-card-field-value">
                              {work.type_of_service?.name || '-'}
                            </span>
                          </div>
                          <div className="work-card-field work-card-field--full">
                            <span className="work-card-field-label">Origem da Vaga</span>
                            <span className="work-card-field-value">{work.type_job || '-'}</span>
                          </div>
                        </div>

                        {launches.length > 0 && (
                          <div style={{ marginTop: 14 }}>
                            <span className="work-card-field-label" style={{ display: 'block', marginBottom: 6 }}>
                              Lançamentos
                            </span>
                            <div className="launch-list">
                              {launches.map((launch) => {
                                const mesesAtivos = MESES_TRABALHO.filter(({ key }) => launch[key]);
                                return (
                                  <div key={launch.id} className="launch-card">
                                    <div className="launch-card-highlight">
                                      <div className="launch-card-highlight-row">
                                        <div>
                                          <span className="launch-card-highlight-label">Período</span>
                                          <span className="launch-card-period">
                                            {formatDate(launch.start_date) || '-'} – {formatDate(launch.end_date) || 'Atual'}
                                          </span>
                                        </div>
                                      </div>
                                      <div>
                                        <span className="launch-card-highlight-label">Meses trabalhados</span>
                                        <div className="launch-card-months">
                                          {mesesAtivos.length > 0
                                            ? mesesAtivos.map(({ key, label }) => (
                                                <span key={key} className="launch-month-badge">
                                                  {label} ({launch.worked_days_by_month?.[key] ?? 0})
                                                </span>
                                              ))
                                            : <span style={{ color: '#adb5bd', fontSize: 12 }}>Nenhum mês calculado</span>
                                          }
                                        </div>
                                      </div>
                                    </div>
                                    <div className="launch-card-info">
                                      {launch.regime_name && (
                                        <span className="launch-card-info-item">
                                          <strong>Regime:</strong> {launch.regime_name}
                                        </span>
                                      )}
                                      <span className="launch-card-info-item">
                                        <strong>Estuda:</strong> {launch.studying ? 'Sim' : 'Não'}
                                      </span>
                                      <span className="launch-card-info-item">
                                        <strong>Dias trabalhados:</strong> {launch.total_worked_days ?? 0}
                                      </span>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : renderAccordionEmptyState()
          ) : null}
        </div>

        {/* Acordeon de Psicologia */}
        <div className={`content ${accordionState.psicologia ? 'open' : ''}`}>
          <h4 className='h4-title title-accordion' onClick={() => toggleAccordion('psicologia')}>
            Psicologia <FontAwesomeIcon className='icon-accordion' icon={accordionState.psicologia ? faChevronRight : faChevronDown} />
          </h4>
          {accordionState.psicologia ? (
            psychologyData ? (
              <div className="social-service-details">
                <div>
                  <div>
                    <h5>Transtornos Mentais:</h5>
                    <p>{formatListNames(safeArray(psychologyData.mental_disorder_list, 'psychologyData.mental_disorder_list'), 'Nenhum')}</p>
                  </div>
                  <div>
                    <h5>Tratamento Psicológico:</h5>
                    <p>{psychologyData.psychological_treatment}</p>
                  </div>
                  <div>
                    <h5>Saúde Mental:</h5>
                    <p>{psychologyData.mental_health}</p>
                  </div>
                  <div>
                    <h5>Linguagem:</h5>
                    <p>{psychologyData.linguage}</p>
                  </div>
                  <div>
                    <h5>Pensamento:</h5>
                    <p>{psychologyData.thinking}</p>
                  </div>
                  <div>
                    <h5>Aparência Física:</h5>
                    <p>{psychologyData.physical_appearance}</p>
                  </div>
                  <div>
                    <h5>Higiene:</h5>
                    <p>{psychologyData.hygiene}</p>
                  </div>
                  <div>
                    <h5>Deseja Serviço:</h5>
                    <p>{psychologyData.want_service ? 'Sim' : 'Não'}</p>
                  </div>
                  <div>
                    <h5>Recomendações:</h5>
                    <p>{psychologyData.observation}</p>
                  </div>
                </div>
                <div className='arquivo'>
                  <h5>Arquivo:</h5>
                  {hasBinaryField(psychologyData, 'file') ? (
                    <BinaryFileLink resource={BINARY_RESOURCES.receptionPsychology} id={psychologyData.id} field="file">
                      <img src={FileIcon} alt='Incone' /> ver
                    </BinaryFileLink>
                  ) : (
                    <span>Sem arquivo</span>
                  )}
                </div>
              </div>
            ) : renderAccordionEmptyState()
          ) : null}

        </div>

        {/* Acordeon de Odonto */}
        <div className={`content ${accordionState.odontologia ? 'open' : ''}`}>
          <h4 className='h4-title title-accordion' onClick={() => toggleAccordion('odontologia')}>
            Odontologia <FontAwesomeIcon className='icon-accordion' icon={accordionState.odontologia ? faChevronRight : faChevronDown} />
          </h4>
          {accordionState.odontologia ? (
            odontologyData ? (
              <div className="social-service-details">
                <div>

                  <div>
                    <h5>Queixa pincipal:</h5>
                    <p>{odontologyData.main_complaint}</p>
                  </div>
                  <div>
                    <h5>Dentição:</h5>
                    <p>{odontologyData.dentition}</p>
                  </div>
                  <div>
                    <h5>Tecido Mole:</h5>
                    <p>{odontologyData.soft_tissue}</p>
                  </div>
                  <div>
                    <h5>Gengivas e Periodonto:</h5>
                    <p>{odontologyData.gums_and_periodontium}</p>
                  </div>
                  <div>
                    <h5>Edema:</h5>
                    <p>{odontologyData.edema}</p>
                  </div>
                  <div>
                    <h5>Língua:</h5>
                    <p>{odontologyData.tongue}</p>
                  </div>
                  <div>
                    <h5>Mobilidade:</h5>
                    <p>{odontologyData.mobility}</p>
                  </div>
                  <div>
                    <h5>Higiene Oral:</h5>
                    <p>{odontologyData.oral_hygiene}</p>
                  </div>
                  <div>
                    <h5>Outros problemas:</h5>
                    <p>{odontologyData.other_problems}</p>
                  </div>
                </div>

                <h4>Evoluções</h4>

                {odontologyEvolutions.length > 0 ? (
                  <ul className="timeline-list">
                    {odontologyEvolutions.map((evo, index) => (
                      <li key={index} className="timeline-item">
                        <div className="timeline-date">
                          <FontAwesomeIcon icon={faClock} />{" "}
                          {new Date(evo.date).toLocaleString()}
                        </div>
                        <div className="timeline-content">
                          <p><strong>Dente:</strong> {evo.tooth_number}</p>
                          <p><strong>Procedimento:</strong> {evo?.procedure?.name || evo.procedure}</p>
                        </div>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p>Nenhuma evolução registrada.</p>
                )}
              </div>
            ) : renderAccordionEmptyState()
          ) : null}

        </div>

        {/* Acordeon de saude */}
        <div className={`content ${accordionState.saude ? 'open' : ''}`}>
          <h4 className='h4-title title-accordion' onClick={() => toggleAccordion('saude')}>
            Admissão saúde <FontAwesomeIcon className='icon-accordion' icon={accordionState.saude ? faChevronRight : faChevronDown} />
          </h4>
          {accordionState.saude ? (
            healthData ? (
              <div className="social-service-details admission-health-details">
                <div className="admission-health-grid">
                  <div className="admission-health-card">
                    <h5>HDA/DIN:</h5>
                    <p>{formatValue(healthData.hda_din)}</p>
                  </div>
                  <div className="admission-health-card">
                    <h5>Nivél de Consciência:</h5>
                    <p>{healthData.level_of_consciousness?.name}</p>
                  </div>
                  <div className="admission-health-card">
                    <h5>Pupilas:</h5>
                    <p>{healthData.pupils?.name}</p>
                  </div>
                  <div className="admission-health-card">
                    <h5>Comunicação:</h5>
                    <p>{healthData.communication?.name}</p>
                  </div>
                  <div className="admission-health-card">
                    <h5>Locomoção:</h5>
                    <p>{healthData.locomotion?.name}</p>
                  </div>
                  <div className="admission-health-card">
                    <h5>Tipo de auxílio de locomoção:</h5>
                    <p>{formatValue(healthData.type_mobility_aid)}</p>
                  </div>
                  <div className="admission-health-card">
                    <h5>Usuário de Drogas:</h5>
                    <p>{formatYesNo(healthData.drug_user)}</p>
                  </div>
                  <div className="admission-health-card">
                    <h5>Alcoólatra:</h5>
                    <p>{formatYesNo(healthData.alcoholic)}</p>
                  </div>
                  <div className="admission-health-card">
                    <h5>Fumante:</h5>
                    <p>{formatYesNo(healthData.smoker)}</p>
                  </div>
                  <div className="admission-health-card">
                    <h5>Drogas Utilizadas:</h5>
                    <p>{formatListNames(healthData.drugs)}</p>
                  </div>
                  <div className="admission-health-card">
                    <h5>Vacina atualizada?:</h5>
                    <p>{formatYesNo(healthData.vaccination_updated)}</p>
                  </div>
                  <div className="admission-health-card">
                    <h5>Observação vacinal:</h5>
                    <p>{formatValue(healthData.vaccination_observation)}</p>
                  </div>
                  <div className="admission-health-card">
                    <h5>Dispositivos ou drenos:</h5>
                    <p>{formatListNames(healthData.devices_or_drains)}</p>
                  </div>
                  <div className="admission-health-card">
                    <h5>Alergias:</h5>
                    <p>{formatListNames(healthData.allergy)}</p>
                  </div>
                  <div className="admission-health-card admission-health-card--wide">
                    <h5>Sinais vitais:</h5>
                    <p>
                      PA: {formatValue(healthData.vital_signs?.pa)} / P: {formatValue(healthData.vital_signs?.p)} / T: {formatValue(healthData.vital_signs?.t)} / HGT: {formatValue(healthData.vital_signs?.hgt)} / SpO₂: {formatValue(healthData.vital_signs?.spo2)}
                    </p>
                  </div>
                  <div className="admission-health-card admission-health-card--wide">
                    <h5>Status nutricional:</h5>
                    <p>
                      Peso: {formatValue(healthData.nutritional_status?.weight)} / Altura: {formatValue(healthData.nutritional_status?.height)} / IMC: {formatValue(healthData.nutritional_status?.imc)}
                    </p>
                  </div>
                  <div className="admission-health-card">
                    <h5>Evolução:</h5>
                    <p>{formatValue(healthData.observation)}</p>
                  </div>
                  <div className="admission-health-card">
                    <h5>Arquivo:</h5>
                    {hasBinaryField(healthData, 'file') ? (
                      <BinaryFileLink resource={BINARY_RESOURCES.admission} id={healthData.id} field="file">
                        <img src={FileIcon} alt='Arquivo' /> ver
                      </BinaryFileLink>
                    ) : (
                      <p>Não informado</p>
                    )}
                  </div>
                  <div className="admission-health-card admission-health-card--wide">
                    <h5>Prescrições:</h5>
                    {safeArray(healthData.prescriptions?.items, 'healthData.prescriptions.items').length > 0 ? (
                      safeArray(healthData.prescriptions?.items, 'healthData.prescriptions.items').map((item) => (
                        <div key={item.id || item.name}>
                          <p>{formatPrescriptionLine(item)}</p>
                          {hasBinaryField(item, 'file') && (
                            <BinaryFileLink resource={BINARY_RESOURCES.medicalPrescription} id={item.id} field="file">
                              <img src={FileIcon} alt='Arquivo' /> ver
                            </BinaryFileLink>
                          )}
                        </div>
                      ))
                    ) : (
                      <p>Nenhuma</p>
                    )}
                  </div>
                  <div className="admission-health-card admission-health-card--wide">
                    <h5>Encaminhamentos:</h5>
                    {safeArray(healthData.forwardings?.items, 'healthData.forwardings.items').length > 0 ? (
                      safeArray(healthData.forwardings?.items, 'healthData.forwardings.items').map((item) => (
                        <div key={item.id || item.regulation}>
                          <p>{formatForwardingLine(item)}</p>
                          {hasBinaryField(item, 'file') && (
                            <BinaryFileLink resource={BINARY_RESOURCES.internalForwarding} id={item.id} field="file">
                              <img src={FileIcon} alt='Arquivo' /> ver
                            </BinaryFileLink>
                          )}
                        </div>
                      ))
                    ) : (
                      <p>Nenhum</p>
                    )}
                  </div>
                </div>
              </div>
            ) : renderAccordionEmptyState()
          ) : null}

        </div>

        {/* Acordeon de nutrição */}
        <div className={`content ${accordionState.nutricao ? 'open' : ''}`}>
          <h4 className='h4-title title-accordion' onClick={() => toggleAccordion('nutricao')}>
            Nutrição <FontAwesomeIcon className='icon-accordion' icon={accordionState.nutricao ? faChevronRight : faChevronDown} />
          </h4>
          {accordionState.nutricao ? (
            nutritionData ? (
              <div className="social-service-details">
                <div>

                  <div>
                    <h5>Peso:</h5>
                    <p>{nutritionData.weight}</p>
                  </div>
                  <div>
                    <h5>Altura:</h5>
                    <p>{nutritionData.height}</p>
                  </div>
                  <div>
                    <h5>IMC:</h5>
                    <p>{nutritionData.imc}</p>
                  </div>
                  <div>
                    <h5>Classificação:</h5>
                    <p>{nutritionData.classification}</p>
                  </div>
                  <div>
                    <h5>Riscos Nutricionais:</h5>
                    <p>{nutritionData.nutritional_risk}</p>
                  </div>
                  <div>
                    <h5>Dieta Específica:</h5>
                    <p>{nutritionData.specific_diet_therapy}</p>
                  </div>
                  <div>
                    <h5>Dieta personalizada</h5>
                    <p>{nutritionData.Diet_Specification}</p>
                  </div>

                </div>
                <div className='arquivo'>
                  <h5>Arquivo:</h5>
                  {hasBinaryField(nutritionData, 'file') ? (
                    <BinaryFileLink resource={BINARY_RESOURCES.nutritionalStatus} id={nutritionData.id} field="file">
                      <img src={FileIcon} alt='Incone' /> ver
                    </BinaryFileLink>
                  ) : (
                    <span>Sem arquivo</span>
                  )}
                </div>
              </div>
            ) : renderAccordionEmptyState()
          ) : null}

        </div>

        {/* Acordeon Visitantes */}
        <div className={`content ${accordionState.visitantes ? 'open' : ''}`}>
          <h4 className='h4-title title-accordion' onClick={() => toggleAccordion('visitantes')}>
            Visitantes <FontAwesomeIcon className='icon-accordion' icon={accordionState.visitantes ? faChevronRight : faChevronDown} />
          </h4>
          {accordionState.visitantes ? (
            internalDetails ? (
              <div className='content-table'>
                {isLoadingVisitors ? (
                  <p>Carregando visitantes...</p>
                ) : relatedVisitors.length > 0 ? (
                  <table>
                    <thead>
                      <tr>
                        <th>Nome</th>
                        <th>CPF</th>
                        <th>Tipo de visitante</th>
                        <th>Parentesco</th>
                        <th>Autorização de entrada</th>
                        <th>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {relatedVisitors.map((visitor) => (
                        <tr key={visitor?.id || `${visitor?.cpf || 'visitor'}-${visitor?.name || ''}`}>
                          <td>{visitor?.name || '-'}</td>
                          <td>{formatCPF(String(visitor?.cpf || '').replace(/\D/g, '')) || '-'}</td>
                          <td>{formatTypeVisitors(visitor?.type_visitor)}</td>
                          <td>{getRelationshipWithCurrentInternal(visitor)}</td>
                          <td>{getVisitorEntryAuthorizationLabel(visitor)}</td>
                          <td>
                            <VisibleAccess
                              compareField="groups"
                              compareValues={VISITOR_DETAILS_ALLOWED_GROUPS}
                              fallback='-'
                            >
                              {visitor?.id ? (
                                <Link to={`/detalhes-visitantes/${visitor.id}`} className='btnEditar' title='Visualizar visitante'>
                                  <FontAwesomeIcon icon={faEye} />
                                </Link>
                              ) : (
                                '-'
                              )}
                            </VisibleAccess>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  renderAccordionEmptyState()
                )}
              </div>
            ) : renderAccordionEmptyState()
          ) : null}
        </div>


        {isInclusionWizardOpen && (
          <Modal
            title={'Ficha de Inclusão'}
            isOpen={isInclusionWizardOpen}
            closeModal={handleCloseInclusionWizard}
          >
            <div className="register-steps" style={{ padding: '0 0 12px', gridTemplateColumns: 'repeat(2, 1fr)' }}>
              <div className={`register-step ${inclusionWizardStep >= 1 ? 'active' : ''}`}>
                <span>1</span>
                <p>Preencher ficha</p>
              </div>
              <div className={`register-step ${inclusionWizardStep >= 2 ? 'active' : ''}`}>
                <span>2</span>
                <p>Upload assinado</p>
              </div>
            </div>

            {inclusionWizardStep === 1 && (
              <div className="inclusion-step" style={{ padding: '12px 0 0' }}>
                <div className="inclusion-form">
                  <div className="inclusion-section">
                    <h5>Identificação do interno</h5>
                    <div className="form-group">
                      <div className="form-field">
                        <label>Nome:</label>
                        <input name="name" value={inclusionFormData.name} onChange={handleInclusionFormChange} />
                      </div>
                      <div className="form-field">
                        <label>Vulgo:</label>
                        <input name="nickname" value={inclusionFormData.nickname} onChange={handleInclusionFormChange} />
                      </div>
                      <div className="form-field">
                        <label>Idade:</label>
                        <input
                          type="number"
                          min="18"
                          max="100"
                          name="age"
                          value={inclusionFormData.age}
                          onChange={handleInclusionFormChange}
                        />
                      </div>
                      <div className="form-field">
                        <label>Naturalidade:</label>
                        <LocationAutocomplete
                          kind="city"
                          name="naturalness_city"
                          value={inclusionNaturalnessName}
                          onChange={handleInclusionNaturalnessChange}
                          onSelect={handleInclusionNaturalnessSelect}
                        />
                      </div>
                      <div className="form-field">
                        <label>CPF:</label>
                        <FormattedInput type="cpf" name="cpf" value={inclusionFormData.cpf} onChange={handleInclusionFormChange} />
                      </div>
                    </div>
                  </div>

                  <div className="inclusion-section">
                    <h5>Informações gerais estado de saúde</h5>
                    <div className="form-group">
                      <div className="form-field">
                        <label>Está gestante:</label>
                        <select name="pregnancy" value={String(inclusionFormData.pregnancy)} onChange={handleInclusionFormChange}>
                          <option value="false">Não</option>
                          <option value="true">Sim</option>
                        </select>
                      </div>
                      {inclusionFormData.pregnancy && (
                        <div className="form-field">
                          <label>Tempo de gravidez:</label>
                          <input name="pregnancy_time" value={inclusionFormData.pregnancy_time} onChange={handleInclusionFormChange} />
                        </div>
                      )}
                      <div className="form-field inclusion-textarea">
                        <label>Outras enfermidades / situação de saúde no momento:</label>
                        <textarea name="health_situation" value={inclusionFormData.health_situation} onChange={handleInclusionFormChange} rows={3} />
                      </div>
                    </div>
                  </div>

                  <div className="inclusion-section">
                    <h5>Material entregue à interna</h5>
                    <div className="form-group">
                      <div className="form-field">
                        <label>Recebeu uniforme completo:</label>
                        <select name="full_uniform" value={String(inclusionFormData.full_uniform)} onChange={handleInclusionFormChange}>
                          <option value="false">Não</option>
                          <option value="true">Sim</option>
                        </select>
                      </div>
                      {inclusionFormData.full_uniform && (
                        <div className="form-field inclusion-textarea">
                          <label>Observação do uniforme:</label>
                          <textarea name="observation_uniforms" value={inclusionFormData.observation_uniforms} onChange={handleInclusionFormChange} rows={3} />
                        </div>
                      )}
                      <div className="form-field">
                        <label>Recebeu kit higiene:</label>
                        <select name="hygiene_kit" value={String(inclusionFormData.hygiene_kit)} onChange={handleInclusionFormChange}>
                          <option value="false">Não</option>
                          <option value="true">Sim</option>
                        </select>
                      </div>
                      {inclusionFormData.hygiene_kit && (
                        <div className="form-field inclusion-textarea">
                          <label>Observação do kit higiene:</label>
                          <textarea name="observation_hygiene_kit" value={inclusionFormData.observation_hygiene_kit} onChange={handleInclusionFormChange} rows={3} />
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="inclusion-section">
                    <h5>Itens recolhidos</h5>
                    <div className="form-group">
                      <div className="form-field inclusion-textarea">
                        <label>Vestuário que chegou:</label>
                        <textarea name="clothing" value={inclusionFormData.clothing} onChange={handleInclusionFormChange} rows={3} />
                      </div>
                      <div className="form-field inclusion-textarea">
                        <label>Documentos recolhidos:</label>
                        <select name="documents_collected" value={String(inclusionFormData.documents_collected)} onChange={handleInclusionFormChange}>
                          <option value="false">Não</option>
                          <option value="true">Sim</option>
                        </select>
                      </div>
                      {inclusionFormData.documents_collected && (
                        <div className="form-field inclusion-textarea">
                          <label>Observação documentos recolhidos:</label>
                          <textarea name="observation_documents" value={inclusionFormData.observation_documents} onChange={handleInclusionFormChange} rows={3} />
                        </div>
                      )}
                      <div className="form-field">
                        <label>Outros itens recolhidos (joias, dinheiro, etc.):</label>
                        <select name="other_items_collected" value={String(inclusionFormData.other_items_collected)} onChange={handleInclusionFormChange}>
                          <option value="false">Não</option>
                          <option value="true">Sim</option>
                        </select>
                      </div>
                      {inclusionFormData.other_items_collected && (
                        <div className="form-field inclusion-textarea">
                          <label>Descrever itens recolhidos:</label>
                          <textarea name="observation_other_items" value={inclusionFormData.observation_other_items} onChange={handleInclusionFormChange} rows={3} />
                        </div>
                      )}
                      <div className="form-field">
                        <label>Data de inclusão:</label>
                        <input type="date" name="inclusion_date" value={inclusionFormData.inclusion_date} onChange={handleInclusionFormChange} />
                      </div>
                    </div>
                  </div>

                  <div className="inclusion-section">
                    <h5>Observações</h5>
                    <div className="form-group">
                      <div className="form-field inclusion-textarea">
                        <label>Observação:</label>
                        <textarea name="others" value={inclusionFormData.others} onChange={handleInclusionFormChange} rows={3} />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="inclusion-actions">
                  <button type="button" className="btn-secondary" onClick={handleCloseInclusionWizard}>
                    Cancelar
                  </button>
                  <button type="button" className="btn-primary" onClick={handleGenerateInclusionPdf}>
                    Gerar PDF e avançar
                  </button>
                </div>
              </div>
            )}

            {inclusionWizardStep === 2 && (
              <div className="inclusion-step" style={{ padding: '12px 0 0' }}>
                <div className="inclusion-upload">
                  <p>
                    Faça o upload do arquivo assinado (PDF ou imagem).
                    <span className="required-indicator">*</span>
                  </p>

                  {hasBinaryField(existingInclusionRecord, 'file') && (
                    <p className="existing-file">
                      Arquivo atual: <BinaryFileLink resource={BINARY_RESOURCES.internalInclusion} id={existingInclusionRecord.id} field="file">Visualizar</BinaryFileLink>
                    </p>
                  )}

                  <div className="inclusion-actions" style={{ justifyContent: 'flex-start', marginBottom: '10px' }}>
                    <button type="button" className="btn-secondary" onClick={handleInclusionUploadContainerClick}>
                      Abrir câmera
                    </button>
                    <button type="button" className="btn-secondary" onClick={() => openFileDialog(inclusionFileInputRef)}>
                      Escolher arquivo
                    </button>
                  </div>

                  <div
                    className={`image-upload-container ${showInclusionWebcam ? 'webcam-active' : ''}`}
                    onClick={() => {
                      if (!showInclusionWebcam) {
                        openFileDialog(inclusionFileInputRef);
                      }
                    }}
                  >
                    <input
                      ref={inclusionFileInputRef}
                      type="file"
                      accept="application/pdf,image/*"
                      onChange={handleInclusionUploadChange}
                      onClick={(e) => e.stopPropagation()}
                      className="image-input"
                      style={{ display: 'none' }}
                    />
                    <input
                      ref={inclusionCameraInputRef}
                      type="file"
                      accept="image/*"
                      onChange={handleInclusionUploadChange}
                      onClick={(e) => e.stopPropagation()}
                      className="image-input"
                      capture="environment"
                      style={{ display: 'none' }}
                    />

                    {showInclusionWebcam ? (
                      <div
                        className="image-upload-webcam"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <Webcam
                          ref={inclusionWebcamRef}
                          screenshotFormat="image/jpeg"
                          videoConstraints={{ facingMode: { ideal: 'environment' } }}
                          onUserMediaError={() =>
                            setInclusionCameraError('Não foi possível acessar a câmera. Verifique as permissões.')
                          }
                        />

                        <div className="image-upload-actions">
                          <button
                            type="button"
                            className="btn-primary"
                            onClick={captureInclusionFromWebcam}
                          >
                            Tirar foto
                          </button>
                          <button
                            type="button"
                            className="btn-secondary"
                            onClick={() => openFileDialog(inclusionFileInputRef)}
                          >
                            Escolher arquivo
                          </button>
                          <button
                            type="button"
                            className="btn-secondary"
                            onClick={cancelInclusionWebcam}
                          >
                            Cancelar
                          </button>
                        </div>

                        {inclusionCameraError && (
                          <p className="camera-error">{inclusionCameraError}</p>
                        )}
                      </div>
                    ) : (
                      inclusionUploadPreview ? (
                        <img
                          src={inclusionUploadPreview}
                          alt="Prévia do arquivo assinado"
                          className="preview-image"
                        />
                      ) : (
                        <>
                          <img src={ImgPlaceholder} alt="Selecionar arquivo assinado" className="upload-icon" />
                          <span>
                            {inclusionUploadFile
                              ? `Arquivo selecionado: ${inclusionUploadFile.name || 'arquivo'}`
                              : 'Adicionar imagem ou PDF'}
                          </span>
                        </>
                      )
                    )}
                  </div>

                  {inclusionUploadFile && !inclusionUploadPreview && (
                    <p className="existing-file">
                      Arquivo selecionado: {inclusionUploadFile.name || 'arquivo'}
                    </p>
                  )}
                </div>

                <div className="inclusion-actions">
                  <button type="button" className="btn-secondary" onClick={handleBackToInclusionForm}>
                    Voltar para ficha
                  </button>
                  <button
                    type="button"
                    className="btn-primary"
                    onClick={handleFinalizeInclusionWizard}
                    disabled={isSavingInclusion}
                  >
                    {isSavingInclusion ? 'Salvando...' : 'Salvar ficha'}
                  </button>
                </div>
              </div>
            )}
          </Modal>
        )}

        {/* Modal de adicionar imagens */}
        {isModalOpen && (
          <AddImage
            internalId={internalId}
            isOpen={isModalOpen}
            closeModal={() => setIsModalOpen(false)}
            onSaveSuccess={updateInternalImages}
          />
        )}

        {/* Modal de editar Interno */}
        {isModalEditInternalOpen && (
          <Modal title={'Dados do Interno'} size='large' isOpen={isModalEditInternalOpen} closeModal={() => setIsModalEditInternalOpen(false)}>
            <EditInternal
              internalDetails={internalDetails}
              onCloseModal={() => setIsModalEditInternalOpen(false)}
              onSaveSuccess={() => { fetchInternalDetails(); }}
              unitId={internalDetails.unit}
              updateInternal={updateInternal}
            />
          </Modal>
        )}

        {/* Modal de adicionar endereço */}
        {isModalAddAddress && (
          <Modal title={'Adicionar Endereço'} isOpen={isModalAddAddress} closeModal={() => setIsModalAddAddress(false)}>
            <AddAddress
              internalId={internalId}
              onSaveSuccess={() => { fetchAddresses(); }}
              onCloseModal={() => setIsModalAddAddress(false)}
            />
          </Modal>
        )}

        {/* Modal de editar endereço */}
        {isModalEditAddress && (
          <Modal
            title={'Editar Endereço'}
            isOpen={isModalEditAddress}
            closeModal={() => setIsModalEditAddress(false)}>
            <EditAddress
              addressData={currentAddress}
              internalId={internalId}
              internalDetails={internalDetails}
              onSaveSuccess={() => {
                fetchAddresses();
                setIsModalEditAddress(false);
              }}
              onCloseModal={() => setIsModalEditAddress(false)}
            />
          </Modal>
        )}

        {/* Modal de adicionar documento */}
        {isModalAddFile && (
          <Modal title={'Adicionar Documento'} isOpen={isModalAddFile} closeModal={() => setIsModalAddFile(false)}>
            <AddDocument
              internalId={internalId}
              onSaveSuccess={() => { fetchFiles(); }}
              onCloseModal={() => setIsModalAddFile(false)}
            />
          </Modal>
        )}

        {/* Modal de detalhes da transferência */}
        {isTransferDetailModalOpen && selectedTransferDetail && (
          <Modal title="Detalhes da Transferência" isOpen={isTransferDetailModalOpen} closeModal={() => { setIsTransferDetailModalOpen(false); setSelectedTransferDetail(null); }}>
            <form className="transfer-modal">
              <div className="transfer-profile-card">
                <div className="transfer-profile-top">
                  <div className="transfer-profile-avatar">
                    {(() => {
                      const name = String(selectedTransferDetail?.internal_name || '').trim();
                      const parts = name.split(/\s+/).filter(Boolean);
                      const initials = parts.length === 0 ? 'IN' : parts.length === 1 ? parts[0].slice(0, 2).toUpperCase() : `${parts[0][0] || ''}${parts[parts.length - 1][0] || ''}`.toUpperCase();
                      // A transferência traz a foto em `image` (registro de internalimage ou null)
                      return (
                        <InternalPhoto internal={selectedTransferDetail} alt={`Foto de ${selectedTransferDetail?.internal_name || 'interno'}`}>
                          <span className="transfer-profile-avatar-fallback">{initials}</span>
                        </InternalPhoto>
                      );
                    })()}
                  </div>
                  <div className="transfer-profile-content">
                    <h3>{selectedTransferDetail?.internal_name || '-'}</h3>
                    <div className="transfer-profile-meta">
                      <span className="transfer-profile-chip">Data: {formatDate(selectedTransferDetail?.date)}</span>
                      {selectedTransferDetail?.received && selectedTransferDetail?.date_recipient && (
                        <span className="transfer-profile-chip">
                          Data de recebimento: {formatDate(selectedTransferDetail.date_recipient)}
                        </span>
                      )}
                      <div className="transfer-profile-status">
                        <span className="transfer-profile-status-label">Status:</span>
                        {(() => {
                          const t = selectedTransferDetail;
                          if ((t.is_active === 1 || t.is_active === true) && !t.received) return <span className="status-vermelho">Pendente</span>;
                          if ((t.is_active === 0 || t.is_active === false) && t.received) return <span className="status-verde">Realizada</span>;
                          if ((t.is_active === 0 || t.is_active === false) && !t.received && t.no_receipt) return <span className="status-amarelo">Recusada</span>;
                          if ((t.is_active === 0 || t.is_active === false) && !t.received && !t.no_receipt) return <span className="status-azul">Cancelada</span>;
                          return null;
                        })()}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="transfer-flow-block">
                  <p className="transfer-profile-subtitle">Fluxo da transferência</p>
                  <div className="transfer-profile-route-board">
                    <div className="transfer-route-card transfer-route-origin">
                      <span className="transfer-route-label">Origem</span>
                      <strong>{selectedTransferDetail?.sender_name || '-'}</strong>
                    </div>
                    <div className="transfer-route-divider" aria-hidden="true">
                      <span className="transfer-route-line"></span>
                      <span className="transfer-route-arrow">→</span>
                      <span className="transfer-route-line"></span>
                    </div>
                    <div className="transfer-route-card transfer-route-destination">
                      <span className="transfer-route-label">Destino</span>
                      <strong>{selectedTransferDetail?.recipient_name || '-'}</strong>
                    </div>
                  </div>
                </div>
              </div>
              <div className="transfer-modal-grid">
                <div className="transfer-modal-field transfer-modal-field-process">
                  <span>Processo</span>
                  <strong>{selectedTransferDetail.process || '-'}</strong>
                </div>
                <div className="transfer-modal-field transfer-modal-field-wide transfer-modal-field-reason">
                  <span>Razão da transferência</span>
                  <strong>{selectedTransferDetail.reason || '-'}</strong>
                </div>
                <div className="transfer-modal-field transfer-modal-field-flag">
                  <span>Transferência ativa</span>
                  <strong>{selectedTransferDetail.is_active ? 'Sim' : 'Não'}</strong>
                </div>
                <div className="transfer-modal-field transfer-modal-field-flag">
                  <span>Foi recebido</span>
                  <strong>{selectedTransferDetail.received ? 'Sim' : 'Não'}</strong>
                </div>
                {selectedTransferDetail.no_receipt && (
                  <div className="transfer-modal-field transfer-modal-field-wide transfer-modal-field-reason">
                    <span>Motivo da recusa</span>
                    <strong>{selectedTransferDetail.no_receipt}</strong>
                  </div>
                )}
              </div>
            </form>
          </Modal>
        )}

        {/* Renderizar a imagem em tamanho grande quando clicada */}
        {showLargeImage && (
          <div className="large-image-overlay" onClick={handleCloseLargeImage}>
            <BinaryImage resource={BINARY_RESOURCES.internalImage} id={largeImageId} field="picture" alt="Imagem" className="large-image" />
            <div className="large-image-details">
              <p><strong>Detalhe:</strong> {largeImageDetailType}</p>
              <p><strong>Descrição:</strong> {largeImageDescription}</p>
            </div>
          </div>
        )}

        <Drawer
          open={isInclusionDrawerOpen}
          onClose={handleCloseInclusionDrawer}
          wide
          title={`Ficha de Inclusão - ${formatInclusionDate(selectedInclusion?.inclusion_date || selectedInclusion?.created_at)}`}
        >
          {selectedInclusion ? (
            <div className="admission-health-details">
              <div className="inclusion-section">
                <h5>Identificação do interno</h5>
                <div className="admission-health-grid">
                  <div className="admission-health-card"><h5>Nome</h5><p>{selectedInclusion.name || '-'}</p></div>
                  <div className="admission-health-card"><h5>Vulgo</h5><p>{selectedInclusion.nickname || '-'}</p></div>
                  <div className="admission-health-card"><h5>CPF</h5><p>{selectedInclusion.cpf || '-'}</p></div>
                  <div className="admission-health-card"><h5>Idade</h5><p>{selectedInclusion.age ?? '-'}</p></div>
                  <div className="admission-health-card"><h5>Naturalidade</h5><p>{selectedInclusion.naturalness_city || selectedInclusion.naturalness || '-'}</p></div>
                </div>
              </div>

              <div className="inclusion-section">
                <h5>Informações gerais estado de saúde</h5>
                <div className="admission-health-grid">
                  <div className="admission-health-card"><h5>Gestante</h5><p>{selectedInclusion.pregnancy ? 'Sim' : 'Não'}</p></div>
                  <div className="admission-health-card"><h5>Tempo de gravidez</h5><p>{selectedInclusion.pregnancy_time || '-'}</p></div>
                  <div className="admission-health-card admission-health-card--wide"><h5>Situação de saúde</h5><p>{selectedInclusion.health_situation || '-'}</p></div>
                </div>
              </div>

              <div className="inclusion-section">
                <h5>Material entregue à interna</h5>
                <div className="admission-health-grid">
                  <div className="admission-health-card"><h5>Uniforme completo</h5><p>{selectedInclusion.full_uniform ? 'Sim' : 'Não'}</p></div>
                  <div className="admission-health-card admission-health-card--wide"><h5>Observação uniforme</h5><p>{selectedInclusion.observation_uniforms || '-'}</p></div>
                  <div className="admission-health-card"><h5>Kit higiene</h5><p>{selectedInclusion.hygiene_kit ? 'Sim' : 'Não'}</p></div>
                  <div className="admission-health-card admission-health-card--wide"><h5>Observação kit higiene</h5><p>{selectedInclusion.observation_hygiene_kit || '-'}</p></div>
                  <div className="admission-health-card admission-health-card--wide"><h5>Observações</h5><p>{selectedInclusion.others || '-'}</p></div>
                </div>
              </div>

              <div className="inclusion-section">
                <h5>Itens recolhidos</h5>
                <div className="admission-health-grid">
                  <div className="admission-health-card"><h5>Documentos recolhidos</h5><p>{selectedInclusion.documents_collected ? 'Sim' : 'Não'}</p></div>
                  <div className="admission-health-card admission-health-card--wide"><h5>Observação documentos</h5><p>{selectedInclusion.observation_documents || '-'}</p></div>
                  <div className="admission-health-card"><h5>Vestuário</h5><p>{selectedInclusion.clothing || '-'}</p></div>
                  <div className="admission-health-card"><h5>Outros itens recolhidos</h5><p>{selectedInclusion.other_items_collected ? 'Sim' : 'Não'}</p></div>
                  <div className="admission-health-card admission-health-card--wide"><h5>Observação outros itens</h5><p>{selectedInclusion.observation_other_items || '-'}</p></div>
                </div>
              </div>

              <div className="inclusion-section">
                <h5>Arquivo e data</h5>
                <div className="admission-health-grid">
                  <div className="admission-health-card"><h5>Data de inclusão</h5><p>{selectedInclusion.inclusion_date || '-'}</p></div>
                  <div className="admission-health-card admission-health-card--wide">
                    <h5>Arquivo assinado</h5>
                    {hasBinaryField(selectedInclusion, 'file') ? (
                      <BinaryFileLink resource={BINARY_RESOURCES.internalInclusion} id={selectedInclusion.id} field="file">Visualizar arquivo</BinaryFileLink>
                    ) : (
                      <p>Não informado</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </Drawer>

      </div>
    </div>
  );
}

export default InternalDetails;
